import { format } from "date-fns";
import useLabels from "../../hooks/useLabels";
import { ChatArea, Input, Label, Switch } from "../FormComponents";
import { Player } from "@lottiefiles/react-lottie-player";
import json_arrow_black from "../../assets/lottieJson/black_arrow.json";
import { useEffect, useState } from "react";
import AnalysisEvolution from "../AnalysisEvolution/AnalysisEvolutions";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../constants/base";
import TableEdit from "../TableEdit";
import { createColumnHelper } from "@tanstack/react-table";
import TableCell from "../TableEdit/TableCell";
import { BottleIcon, CTA, OperationRecap } from "../Generic";
import { empty } from "../../context/operations/operationsSlice";
import { toast } from "react-toastify";
import { addOperationNote } from "../../services/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { socket } from "../../socket";
import QRcodeReader from "../QRcodeReader";
import { selectAnalysisDisplayGrid } from "../../context/selectors";
import { toggleAnalysisDisplayGrid } from "../../context/configs/configsSlice";
import { useSelector } from "react-redux";
import MultipleRowsCell from "../TableEdit/MultipleRowsCell";

// import QRcodeReader from "../QRcodeReader";

const getWineColor = (color) => {
  switch (color) {
    case "WHITE":
      return "white";
    case "ROSE":
      return "rose";
    default:
      return "red";
  }
};

const actualizeSrcTank = (type, completion_date = null, destTank, tanks, is_src = false) => {
  // if not completed, compute tankData from current tanks
  if (completion_date !== null) {
    if (type === 'RACKING') {
      return {
        ...destTank,
      }
    }
    return destTank;
  }

  const currentTank = tanks?.find(t => t?.id === destTank?.tank_id) || null;

  if (currentTank === null) return {};

  const tankData = {
    ...currentTank,
    color: destTank?.color,
    drop: destTank?.drop,
    old_quantity: currentTank?.quantity,
    old_batch_name: currentTank?.batch_name,
    arrow_quantity: destTank?.arrow_quantity,
    quantity: currentTank?.quantity + (is_src ? -1 : 1) * destTank?.arrow_quantity,
    is_new: destTank?.is_new === true,
    dest: {
      varieties: destTank?.varieties,
      years: destTank?.years,
      origins: destTank?.origins,
      percentages: destTank?.percentages,
    },
    srcs: [{
      varieties: destTank?.src_varieties,
      years: destTank?.src_years,
      origins: destTank?.src_origins,
      percentages: destTank?.src_percentages,
    }],
  };

  if (!tankData.batch_name) tankData.batch_name = destTank?.batch_name;

  return tankData;
}

const isOperationError = (tanks, destTank) => {
  // e.g., due to concurrent operation on the same dest tank
  const currentTank = tanks?.find(t => t?.id === destTank?.tank_id) || null;
  if (currentTank === null) return false;

  return (currentTank?.quantity + destTank?.arrow_quantity) > currentTank?.capacity;
}

const getRecapTanks = (tanks, operation, isSrc = true) => {
  const tankList = [];

  const isCompleted = operation?.completion_date !== null;
  const tmpTanks = (isSrc ? operation?.src_tanks : operation?.dest_tanks) || [];
          
  tmpTanks?.forEach((t) => {
  
      if (isCompleted) {
        if (isSrc)
          tankList.push({ tankData: {...t?.postOperation?.tank, lot: t?.postOperation?.tank?.batch_name, quantity: t?.quantity - t?.postOperation?.tank?.arrow_quantity }, new_quantity: String(t?.postOperation?.tank?.quantity), toRemove: t?.postOperation?.tank?.arrow_quantity, quantity: Math.abs(t?.postOperation?.tank?.arrow_quantity), capacity: t?.postOperation?.tank?.capacity, lot: t?.postOperation?.tank?.batch_name, name: t?.postOperation?.tank?.name, color: t?.postOperation?.tank?.color || t?.postOperation?.batch?.color })
        else {
          tankList.push({ tankData: {...t?.postOperation?.tank, quantity: t?.postOperation?.tank?.old_quantity, value: true }, quantity: t?.new_quantity - (operation?.type === 'RACKING' ? t?.postOperation?.tank?.drop : 0), batch_name_selector: { value: false, label: t?.new_batch_name}, drop: 0*t?.postOperation?.tank?.drop, ...(operation?.type === 'RACKING' && { batch_type: t?.batch_type }), lot: t?.postOperation?.tank?.batch_name, color: t?.postOperation?.tank?.color || t?.postOperation?.batch?.color })
        }
        // TO DO RACKING con cali non funziona, forse non va mai quando ci sono cali
      } else {
        const tank = tanks?.find((s) => s?.id === t?.tank_id);
        if (isSrc) {
          if (operation?.type === 'CUT') tankList.push({ tankData: { ...tank, quantity: Number(t?.preOperation?.tank?.old_quantity), color: t?.preOperation?.batch?.color }, ...tank, quantity: Number(t?.quantity) })
          else tankList.push({ tankData: {...tank }, ...tank })
        } else {
          // TO DO fix batch_type in RACKING and what if src is not emptied by the operation?
          if (operation?.type === 'CUT') tankList.push({ tankData: {...tank, toAdd: t?.quantity, quantity: Number(tank?.quantity), value: true, color: operation?.src_tanks?.[0]?.preOperation?.batch?.color }, quantity: t?.quantity, batch_name_selector: { value: false, label: t?.new_batch_name}, lot: tank?.batch_name })
          else tankList.push({ tankData: {...tank, toAdd: t?.quantity, quantity: Number(tank?.quantity), value: true }, quantity: t?.quantity, batch_name_selector: { value: false, label: t?.new_batch_name}, ...(operation?.type === 'RACKING' && { batch_type: t?.batch_type }), lot: tank?.batch_name, color: tank?.color })
        }
      }
    })
    
  return tankList;
}

export const DestLotDetail = ({
  lot,
  operation,
  toRemove = null,
  isName = true,
  isRecap = false,
  isDestemming = false,
  isNewLot = false,
  isAdditional = false,
  isMobile = false,
  isDetail = false,
}) => {
  const [getLabel] = useLabels();

  const getAdditional = () => {
    
    if (!lot) return <p></p>;
    const additional = [];
    for (let i = 0; i < lot?.varieties?.length; i++) {
      const v = lot?.varieties?.[i] ? getLabel(`lotVarieties_${lot?.varieties?.[i]}`) : '';
      const y = lot?.years?.[i] ? ` [${lot?.years?.[i]}]` : '';
      const o = lot?.origins?.[i] ? `, ${lot?.origins?.[i]}` : '';
      const p = lot?.percentages?.length > 1 ? ` (${lot?.percentages?.[i]}%)` : "";
      additional.push(`${v}${p}${o}${y}`);
    }

    return (
      <div className={`additional ${isMobile ? "smaller" : ""}`}>{additional?.map((a, i) => { return <p key={`additional_${i}`}>{a}</p>})}</div>
    )
  }

  return (
    <div className={`lot_wrapper ${!isRecap ? "" : "recap"}`}>
      {isName && (
        <div className={`lot_name ${!isRecap ? "" : "recap"} ${!isDetail ? "" : "detail"}`}>
          {lot?.name || ''}
          {isAdditional && isMobile && getAdditional()} 
        </div>
      )} 
      {!isDestemming && <><div className="init_status">
        <div className="tank_header">
          <p>{getLabel('operationDetailBefore')}</p>
        </div>
        <div className="lot_representation">
          <div
            className={
              "lot_progress_" + getWineColor(lot?.color)
            }
            style={{
              height: `${
                (Number(lot?.old_quantity) / Number(lot?.initial_quantity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div className={!isRecap ? "lot_quantity" : ""}>
          {lot?.old_quantity || 0} / {lot?.initial_quantity}Kg (
          {Math.round(
            ((Number(lot?.old_quantity) || 0) * 100) / Number(lot?.initial_quantity)
          )}
          %)
        </div>
      </div>
      <div className="arrow">
        {isMobile && <div className="fake-line-wrapper"><div className="fake-line"></div></div>}
        {`-${Number(
          lot?.arrow_quantity
        )} ${isNewLot ? 'L' : 'Kg'}`}
        <Player
          autoplay={false}
          controls={false}
          hover={false}
          src={json_arrow_black}
          style={{ width: "24px", height: "24px", transform: "rotate(180deg)" }}
        />
      </div></>}
      <div className={`end_status ${isRecap ? 'unset-width' : ''}`}>
        {!isRecap && <div className="tank_header">
            <p>{getLabel('operationDetailAfter')}</p>
        </div>}
      {isDestemming && <h6 className="bold centered">{lot?.label}</h6>}
        <div className="lot_representation">
          <div
            className={
              "lot_progress_" + getWineColor(lot?.color)
            }
            style={{
              height: `${
                ((Number(lot?.quantity) - (isRecap && toRemove > 0 ? Number(toRemove) : 0)) / Number(lot?.initial_quantity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div className="lot_quantity">
          {(Number(lot?.quantity) - (isRecap && toRemove > 0 ? Number(toRemove) : 0)) || 0} / {lot?.initial_quantity}
          {isNewLot ? "L" : "Kg"} (
          {Math.round(
            ((Number(lot?.quantity)  - (isRecap && toRemove > 0 ? Number(toRemove) : 0) || 0) * 100) / Number(lot?.initial_quantity)
          )}
          %)
          {isRecap && toRemove > 0 && <h6 className="bold">{`-${Number(toRemove) || 0} Kg`}</h6>}
        </div>
      </div>
      {isAdditional && !isMobile && getAdditional()} 
    </div>
  );
};

export const DestBottlingDetail = ({
  bottleLot,
  capLot,
  batches = [],
  srcBatches = [],
}) => {
  const [getLabel] = useLabels();

  const getWineColor = (color) => {
    switch (color) {
      case "WHITE":
        return "rgb(249, 213, 115)";
      case "ROSE":
        return "rgb(199, 79, 89)";
      default:
        return "#64242e";
    }
  };

  return (
    <div className="bottling">
      <div className="box_icons">
        {batches?.map((batch, index) => {
          const srcBatch = srcBatches?.find((b) => b?.batch_id === batch?.batch_id)?.preOperation?.batch || {};
          return (
            <div key={`batch-${index}`} className="box_item">
              <p className="batch_name">{batch?.new_batch_name}</p>
              <FontAwesomeIcon icon="fa-wine-bottle" className="bottle_icon" style={{color: getWineColor(srcBatch?.color)}} />
              <FontAwesomeIcon icon="fa-box" style={{color: 'rgb(157, 126, 104)'}} size={'4x'} />
            </div>
          );
        })}
      </div>
      <div className="icons">
        <div className="cap_icon">
          <FontAwesomeIcon icon="fa-bread-slice" style={{color: 'rgb(157, 126, 104)'}} size={'sm'}/>
          <p className="line"></p>
          <p className="bold-p">{getLabel('capLot')}<span className="value-p">{capLot || '-'}</span></p>
        </div>

        <div className="bottle_icon">
          <FontAwesomeIcon icon="fa-wine-bottle" className="icon_rotate" style={{color: getWineColor(srcBatches?.[0]?.preOperation?.batch?.color)}} size={'4x'}/>
          <p className="line"></p>
          <p className="bold-p">{getLabel('bottleLot')}<span className="value-p">{bottleLot || '-'}</span></p>
        </div>
      </div>
    </div>
  );
};

export const DestTankDetail = ({
  tank,
  color = null,
  operation,
  isName = true,
  isDrop = true,
  isFirst = false,
  isMobile = false,
}) => {
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [getLabel] = useLabels();
  const [lotInfo, setLotInfo] = useState([]);
  const [showLotInfo, setShowLotInfo] = useState(false);

  useEffect(() => {
    if (tank?.dest && tank?.srcs) {
    setLotInfo(aggregateBlend());
    }
  }, [tank]);

  const aggregateBlend = () => {
    // Convert destination's old quantity to a number.
    const oldQty = parseFloat(tank?.old_quantity) || 0;
    
    // Determine the new wine volume.
    // If there's only one source, use dest.quantity.
    // If there are multiple sources (CUT operation), sum each src.quantity.
    const newQty = Number(tank?.arrow_quantity);
    //  srcTanks.length > 1 
    //   ? srcTanks.reduce((sum, src) => sum + (parseFloat(src?.quantity) || 0), 0)
    //   : (parseFloat(dest?.quantity) || 0);
    const totalVolume = oldQty + newQty;

    // Create an object to hold contributions keyed by "variety|year|origin".
    const contributions = {};
    // Process the destination's preOperation data (existing wine).
    if (tank?.dest) {
      const { varieties, years, origins, percentages } = tank?.dest;
      for (let i = 0; i < (varieties?.length || 0); i++) {
        const variety = varieties[i];
        const year = years[i];
        const origin = origins[i];
        const percentage = parseFloat(percentages[i]) || 0;
        // Compute contribution in liters from existing wine.
        const contribution = oldQty * (percentage / 100);
        const key = `${variety}|${year}|${origin}`;
        contributions[key] = (contributions[key] || 0) + contribution;
      }
    }

    // Process each source's preOperation data.
    tank?.srcs?.forEach(src => {
      if (src) {
        const { varieties, years, origins, percentages } = src;
        // For CUT, each src uses its own quantity; if only one source, it's the same as newQty.
        const srcQty = tank?.srcs?.length > 1 ? (parseFloat(src?.quantity) || 0) : newQty;
        for (let i = 0; i < (varieties?.length || 0); i++) {
          const variety = varieties[i];
          const year = years[i];
          const origin = origins[i];
          const percentage = parseFloat(percentages[i]) || 0;
          const contribution = srcQty * (percentage / 100);
          const key = `${variety}|${year}|${origin}`;
          contributions[key] = (contributions[key] || 0) + contribution;
        }
      }
    });

    // Compute final weighted percentages for each unique combination.
    const result = [];
    for (const key in contributions) {
      const [variety, yearStr, origin] = key.split("|");
      const contribution = contributions[key];
      // Calculate the weighted percentage based on the total wine in the destination.
      const weightedPercentage = (contribution / totalVolume) * 100;
      result.push({
        variety,
        year: Number(yearStr),
        origin,
        percentage: weightedPercentage
      });
    }
    
    // Round the percentages to integers such that they sum exactly to 100.
    return roundPercentages(result);
  };
  
  // Assume aggregated is an array of objects like:
  // [{ variety: "sangiovese", origin: "valle maggiore", year: 2024, percentage: 18.18 }, ...]
  const roundPercentages = (aggregated) => {
    // Step 1: Map to get raw values, rounded value, and remainder.
    const data = aggregated?.map(item => {
      const raw = item?.percentage || 0;
      const rounded = Math.floor(raw); // Round down
      const remainder = raw - rounded;
      return { ...item, raw, rounded, remainder };
    }) || [];
    
    if (data?.length === 0) return { varieties: [], origins: [], years: [], percentages: [] };

    // Step 2: Sum the rounded values.
    let sumRounded = data.reduce((sum, item) => sum + item.rounded, 0);
  
    // Step 3: Calculate the difference to reach 100.
    let diff = 100 - sumRounded;
  
    // Step 4: Sort by remainder descending.
    data.sort((a, b) => b.remainder - a.remainder);
  
    // Step 5: Distribute the difference among the items with highest remainder.
    for (let i = 0; i < diff; i++) {
      if (!data[i]) break;
      data[i].rounded += 1;
    }
  
    const mapData = data?.map(item => ({
      variety: item.variety,
      origin: item.origin,
      year: item.year,
      percentage: item.rounded
    }))
    
    return mapData;
  }

  return (
    <div className="tanks_wrapper">
      {isName && (
        <div className="tank_name">
          {tank?.name}
          {/* {operation?.batch_name_out && <p className="batch_name">{operation?.batch_name_out}</p>} */}
          {/* {tank?.new_batch_name && (
            <p className="batch_name">{tank?.new_batch_name}</p>
          )} */}
        </div>
      )}
      <div className="init_status">
        {isFirst && <div className="tank_header">
          <p>{getLabel('operationDetailBefore')}</p>
        </div>}
          {/* {tank?.old_batch_name && (
            <p className="batch_name">{tank?.old_batch_name}</p>
          )} */}
          <p className="batch_name">{(Number(tank?.old_quantity) > 0 ? tank?.old_batch_name : getLabel("tankState_EMPTY")) || getLabel("tankState_EMPTY")}</p>
          <div className="tank_representation">
          <div
            className={
              "tank_tile_progress_" + getWineColor(color || tank?.color)
            }
            style={{
              height: `${
                (Number(tank?.old_quantity) / Number(tank?.capacity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div>
          {tank?.old_quantity || 0} / {tank?.capacity}L (
          {Math.round(
            ((Number(tank?.old_quantity) || 0) * 100) / Number(tank?.capacity)
          )}
          %)
        </div>
      </div>
      <div className="arrow">
        {isMobile && <div className="fake-line-wrapper"><div className="fake-line"></div></div>}
        {Number(tank?.arrow_quantity) !== 0 && <span>
          {`${Number(tank?.arrow_quantity) >= 0 ? "+" : ""}${Number(tank?.arrow_quantity || 0)} L`}
        </span>}
         {/* {operation?.type === 'DESTEMMING' ? 'KG' : 'L'} */}
        <Player
          autoplay={false}
          controls={false}
          hover={false}
          src={json_arrow_black}
          style={{ width: "24px", height: "24px", transform: "rotate(180deg)" }}
        />
      </div>
      <div className="end_status" onMouseEnter={() => role === ROLES.CLIENT && !isMobile && setShowLotInfo(true)} onMouseLeave={() => role === ROLES.CLIENT && !isMobile && setShowLotInfo(false)}>
      {/* <div className="end_status"> */}
        {isFirst && <div className="tank_header">
          <p>{getLabel('operationDetailAfter')}</p>
        </div>}
        {tank?.batch_name && (
            <p className="batch_name bold">
              {(Number(tank?.quantity) === 0) ? getLabel("tankState_EMPTY") : tank?.batch_name}
              {('is_new' in tank) && <span className="new">
                {tank?.is_new
                  ? getLabel("new")
                  : ""}
              </span>}
            </p>
          )}
        {(tank?.batch_name === undefined || String(tank?.batch_name)?.length === 0) && (
          <p className="no_name">&nbsp;</p>
        )}
        {operation?.type === 'RACKING' && tank?.batch_type && <span className="batch_name">{getLabel(`lotType_${tank?.batch_type}`)}</span>}
        <div className="tank_representation">
          <div
            className={
              "tank_tile_progress_" + getWineColor(color || tank?.color)
            }
            style={{
              height: `${
                ((Number(tank?.quantity) - Number(tank?.drop || 0)) / Number(tank?.capacity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div>
          {(Number(tank?.quantity) - Number(tank?.drop || 0)) || 0} / {tank?.capacity}
          {"L"} (
          {Math.round(
            (((Number(tank?.quantity) - Number(tank?.drop || 0)) || 0) * 100) / Number(tank?.capacity)
          )}
          %)
        </div>
      </div>
      {isDrop && operation?.completion_date !== null && (
        <div className="operation_info_container_row">
          <p className="tank_name">
            {getLabel("operationDrop")}
            <span className="batch_name">
              {" "}
              {`${
                tank?.drop || 0
              }`} {operation?.type === 'DESTEMMING' ? 'Kg' : 'L'}
            </span>
          </p>
        </div>
      )}
      <div className="operation_info_container_row">
        {role === ROLES.CLIENT && lotInfo?.length > 0 && <div className={`lot_info_wrapper ${showLotInfo ? 'visible' : ""}`}>
          {/* {getLabel(!showLotInfo ? "lotInfoMoreDetail" : "lotInfoLessDetail")} */}
          {isMobile && <FontAwesomeIcon
            onClick={() => setShowLotInfo(prev => !prev)}
            icon="fa-angles-right"
            className={`lot_arrow ${showLotInfo ? "open" : ""}`}
          />}
          {showLotInfo && <ul className="lot_info">
            {lotInfo?.map((i, index) => {
                return (
                  <li className="batch_name" key={`varieties-${tank?.name}-${index}`}>
                    {i?.variety || ''}{i?.year ? ` [${i?.year}]` : ''}{i?.origin ? `, ${i?.origin}` : ''}{i?.percentage || '0' ? ` (${i?.percentage}%)` : ''}
                  </li>
                );
              }, "") || ""}
        </ul>}</div>}
      </div>
    </div>
  );
};

export const SrcTankDetail = ({ tank, lot, isCurrentStateOnly = false, totalDrug, isTankNameUp = false }) => {
  const [getLabel] = useLabels();
  let wineColor = "red";
  switch (lot?.color || tank?.color) {
    case "WHITE":
      wineColor = "white";
      break;
    case "ROSE":
      wineColor = "rose";
      break;
    default:
      wineColor = "red";
      break;
  }

  return (
    <div className="tanks_wrapper">
      <div className="tank_name">
        {!isTankNameUp && <p>{tank?.name}</p>}
        {/* {tank?.batch_name && <p className="batch_name">{Number(tank?.quantity) > 0 ? tank?.batch_name || getLabel("tankState_EMPTY") : getLabel("tankState_EMPTY")}</p>} */}
        {/* <div>{operation?.batch_name_out && <div className="batch_name">{operation?.batch_name_out}</div>}</div> */}
      </div>
      <div className="init_wrapper">
        <div className={`init_status ${['TONNEAU', 'BARRIQUE'].includes(tank?.type) ? 'barrel' : ''} ${tank?.type === 'TONNEAU' ? 'tonneau' : ''}`}>
          {tank?.old_batch_name && <p className={`batch_name ${isCurrentStateOnly ? 'bold' : ''}`}>{Number(tank?.old_quantity) > 0 ? tank?.old_batch_name || getLabel("tankState_EMPTY") : getLabel("tankState_EMPTY")}</p>}
          {isTankNameUp && <p>{tank?.name}</p>}
          <div className={`tank_representation ${['TONNEAU', 'BARRIQUE'].includes(tank?.type) ? 'barrel' : ''} ${tank?.type === 'TONNEAU' ? 'tonneau' : ''}`}>
            {/* Secondary level layer (e.g., more wine programmed) */}
            {(isCurrentStateOnly && tank?.planned_quantity && tank?.planned_quantity !== tank?.old_quantity) && <div
              className={`tank_tile_estimated_progress ${wineColor}`}
              style={{ height: `${tank?.planned_quantity}%` }}
            ></div>}
            <div
              className={"tank_tile_progress_" + wineColor}
              style={{
                height: `${
                  (Number(tank?.old_quantity) / Number(tank?.capacity)) * 100
                }%`,
              }}
            >
            </div>
          </div>
          <div>
            {tank?.old_quantity || 0} / {tank?.capacity}L
            {!isTankNameUp ? " (" + Math.round(
              ((Number(tank?.old_quantity) || 0) * 100) /
                Number(tank?.capacity)
            ) + '%)' : ''}
          </div>
          {isTankNameUp && <div>
            {" (" + Math.round(
              ((Number(tank?.old_quantity) || 0) * 100) /
                Number(tank?.capacity)
            ) +
            "%)"}
          </div>}
        </div>
          {totalDrug}
      </div>
      {!isCurrentStateOnly && (
        <>
          <div className="arrow">
            {`-${Number(tank?.arrow_quantity)} L`}
            <Player
              autoplay={false}
              controls={false}
              hover={false}
              src={json_arrow_black}
              style={{
                width: "24px",
                height: "24px",
                transform: "rotate(180deg)",
              }}
            />
          </div>
          <div className={`end_status ${['TONNEAU', 'BARRIQUE'].includes(tank?.type) ? 'barrel' : ''} ${tank?.type === 'TONNEAU' ? 'tonneau' : ''}`}>
            {tank?.batch_name && <p className="batch_name bold">{Number(tank?.quantity) || 0 + Number(tank?.toAdd) || 0  > 0 ? tank?.batch_name || getLabel("tankState_EMPTY") : getLabel("tankState_EMPTY")}</p>}
            <div className={`tank_representation ${['TONNEAU', 'BARRIQUE'].includes(tank?.type) ? 'barrel' :''} ${tank?.type === 'TONNEAU' ? 'tonneau' : ''}`}>
              {(!isCurrentStateOnly && tank?.planned_quantity && tank?.planned_quantity !== tank?.old_quantity) && <div
                className={`tank_tile_estimated_progress ${wineColor}`}
                style={{ height: `${tank?.planned_quantity}%` }}
              ></div>}
              <div
                className={"tank_tile_progress_" + wineColor}
                style={{
                  height: `${
                    ((Number(tank?.quantity) || 0) /
                      Number(tank?.capacity)) *
                    100
                  }%`,
                }}
              ></div>
            </div>
            <div>
              {Number(tank?.quantity) || 0}{" "}
              / {tank?.capacity}
              {"L"} (
              {Math.round(
                ((Number(tank?.quantity) || 0) *
                  100) /
                  Number(tank?.capacity)
              )}
              %)
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const BatchDetail = ({ lot }) => {
  const [getLabel] = useLabels();

  return (
    <>
      <Label label={getLabel("lot")}>{lot?.name}</Label>
    </>
  );
};

export const DestemmingDetail = ({
  operation,
  users,
  tanks,
  configs,
  // batchData,
  register,
  errors,
  getValues,
  setValue,
  axiosPrivate,
  dispatch,
  user_id,
  isNewLot = false,
  userSockets,
  isMobile,
  addChatNote,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [completedState, setCompletedState] = useState([]);

  const setCheckboxState = (tank_id) => {
    const newCompletedState = [...completedState];
    const index = newCompletedState.indexOf(tank_id);
    if (index === -1) {
      newCompletedState.push(tank_id);
    } else {
      newCompletedState.splice(index, 1);
    }
    setCompletedState(newCompletedState);
  };

  const getTankData = (tank) => {
    const tankData = ((operation?.completion_date === null) ? tank?.preOperation?.tank : tank?.postOperation?.tank) || null;
    const color = (((operation?.completion_date === null) ? tank?.preOperation?.batch : tank?.postOperation?.batch)?.color) || operation?.src_tanks?.[0]?.color || null;
    
    return {...tankData, color: color };
  };

  return (
    <>
      <h4>{getLabel('operationDetail')}</h4>
      <div className={`operation_info_container_row ${operation?.cellarman_ids?.length > 1 ? 'start' : ''}`}>
        <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={getLabel("insertionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            configs.shortDateFormat
          )}
        </Label>
        {operation?.completion_date === null && (
          <>
            <Label label={getLabel("expireDate")}>
              {format(
                new Date(operation?.expire_date || null),
                configs.shortDateFormat
              )}
            </Label>
            <Label label={getLabel("cellarman")}>
              {
                <div className="cellarman_container">
                  {operation?.cellarman_ids?.map((cellarman, index) => {
                    const cellarmanName =
                      users?.find?.(
                        (user) => Number(user.id) === Number(cellarman)
                      )?.username || "";
                    return (
                      <div key={`cellarman-${index}`}>
                        {cellarmanName +
                          (operation?.cellarman_ids?.length > 1 ? " " : "")}
                      </div>
                    );
                  })}
                </div>
              }
            </Label>
          </>
        )}
        {operation?.completion_date && (
          <>
            <Label label={getLabel("operationCompletionUser")}>
              <div>
                {users?.find?.(
                  (user) => Number(user.id) === Number(operation?.completed_by)
                )?.username || ""}
              </div>
            </Label>
            <Label label={getLabel("operationCompletionDate")}>
              {format(
                new Date(operation?.completion_date || null),
                configs.dateFormat
              )}
            </Label>
          </>
        )}
        <Label label={getLabel("operationPriority")}>
          {getLabel(`operationPriority${operation?.priority}`)}
        </Label>
        {/* <Label label={getLabel("lotType")}>
          {operation?.batch_type ? getLabel(`lotType${operation?.batch_type}`) : ''}
        </Label> */}
      </div>
      <h4>{getLabel(isNewLot ? "fromLotExternal" : "fromLot")}</h4>
      <div className="operation_info_container_row">
        <div className="tanks_wrapper">
          {!isNewLot && (
            <DestLotDetail
              // lot={operation?.completion_date === null ? operation?.src_tanks?.[0]?.preOperation?.batch : operation?.src_tanks?.[0]?.postOperation?.batch}
              isAdditional={true}
              lot={operation?.src_tanks?.[0]}
              operation={operation}
              isMobile={isMobile}
              isDetail={true}
            />
          )}
          {isNewLot && (
            <>
              <Label label={getLabel("lotNameExternal")}>
                {operation?.src_tanks?.[0]?.name || ""}
              </Label>
              <Label label={getLabel("quantity")}>
                {operation?.src_tanks?.[0]?.arrow_quantity || 0} L
              </Label>
            </>
          )}
        </div>
      </div>
      
      {isNewLot && (
        <div className="operation_info_container_row">
          {operation?.src_tanks?.[0]?.label &&
            operation?.src_tanks?.[0]?.label?.length > 0 && (
              <Label label={getLabel("lotLabel")}>
                {operation?.src_tanks?.[0].label?.map((lab, i) => {
                  return (
                    <p key={`label-${i}`}>{getLabel(`lotLabel_${lab}`)}</p>
                  );
                }, "") || ""}
              </Label>
            )}
          <Label label={getLabel("lotVarieties")}>
            {operation?.src_tanks?.[0]?.varieties?.map((v, i) => {
              return (
                <p key={`variety-${i}`}>
                  {v ? `${getLabel(`lotVarieties_${v}`)} ${operation?.src_tanks?.[0]?.varieties?.length > 1 ? '(' + operation?.src_tanks?.[0]?.percentages?.[i] + '%)' : ''}` : ""}
                </p>
              );
            }, "") || ""}
          </Label>
          <Label label={getLabel("lotYears")}>
            {operation?.src_tanks?.[0]?.years?.map((y, index) => {
              return (
                <p key={`year-${index}`}>
                  {y
                    ? y
                    : index > 0
                    ? operation?.src_tanks?.[0]?.years[index - 1]
                    : ""}
                </p>
              );
            }, "") || ""}
          </Label>
          <Label label={getLabel("lotOrigins")}>
            {operation?.src_tanks?.[0].origins?.map((o, i) => {
              return <p key={`origin-${i}`}>{o}</p>;
            }, "") || ""}
          </Label>
          <Label label={getLabel("lotQuality")}>
            {getLabel(`lotQuality_${operation?.src_tanks?.[0].quality}`)}
          </Label>
          {operation?.src_tanks?.[0]?.color && (
            <Label label={getLabel("lotColor")}>
              {getLabel(`lotColor_${operation?.src_tanks?.[0].color}`)}
            </Label>
          )}
          {operation?.src_tanks?.[0]?.state && (
            <Label label={getLabel("lotState")}>
              {getLabel(`lotState_${operation?.src_tanks?.[0].state}`)}
            </Label>
          )}
        </div>
      )}
      <h4>{getLabel("toTanks")} </h4>
      <ul>
        {operation?.dest_tanks?.map((destTank, idx) => {
          return (
            <li key={`dest-${idx}`}>
              <div className="operation_info_container_row">
                <DestTankDetail
                  // tank={getTankData(destTank)}
                  tank={actualizeSrcTank(operation?.type, operation?.completion_date, destTank, tanks)}
                  // color={batchData?.color}
                  // data={destTank}
                  isDrop={operation?.completion_date !== null}
                  operation={operation}
                  isFirst={idx === 0}
                  isMobile={isMobile}
                ></DestTankDetail>
                {operation?.completion_date === null && isOperationError(tanks, destTank) && (
                    <div className="tank_error">
                      <h5 className="alert_no_info">{getLabel("errorDestTankOperationQuantity")}<br></br><br></br>{getLabel("errorModifyOperationQuantity")}</h5>
                    </div>)
                }
                {operation?.completion_date === null &&
                  (role === 3 ||
                    (role === ROLES.CLIENT &&
                      users?.filter((u) => u?.type === "USER")?.length ===
                        0)) && !isOperationError(tanks, destTank) && (
                    <>
                      <Input
                        name={`completed.${destTank.tank_id}`}
                        register={register}
                        error={errors[`completed.${destTank.tank_id}`]}
                        required={getLabel("inputRequiredError")}
                        isLabel={false}
                        type={"checkbox"}
                        checked={completedState.includes(destTank.tank_id)}
                        onChange={() => setCheckboxState(destTank.tank_id)}
                        customClassName={'confirm'}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                            setCheckboxState(destTank.tank_id); // Change the checkbox state
                            setValue(`completed.${destTank.tank_id}`, !completedState.includes(destTank.tank_id));
                          }
                        }}
                      />
                      {/* <QRcodeReader
                        // fps={10}
                        // qrbox={250}
                        // disableFlip={false}
                        // qrCodeSuccessCallback={onNewScanResult}
                        />  */}
                      {getValues(`completed.${destTank.tank_id}`) && (
                        <Input
                          name={`drop.${destTank.tank_id}`}
                          defaultValue={0}
                          label={getLabel("operationDrop")}
                          placeholder={getLabel("operationDropKgPlaceholder")}
                          register={register}
                          error={errors[`drop`]?.[destTank.tank_id]}
                          required={getLabel("inputRequiredError")}
                          type={"number"}
                          min={{
                            value: 0,
                            message: getLabel("errorMinValue", { value: 0 }),
                          }}
                          max={{
                            value: destTank.quantity - 1, // TO DO: aggiustare coefficiente
                            message: getLabel("errorMaxValue", {
                              value: destTank.quantity - 1,
                            }),
                          }}
                        />
                      )}
                    </>
                  )}
              </div>
            </li>
          );
        })}
      </ul>
      {/* <h4>{getLabel("operationPomaces")} </h4>
      <ul>
        <div>
          <ul>
            {operation?.pomaces?.map((pomace) => {
              return (
                <li>
                  <div>
                    {pomace.dest}: {pomace.quantity || 0}%
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </ul> */}
      {/* <div className="operation_info_container_row">
        <Label label={getLabel("operationNotes")} width={400} height={150} customClassName={"notes"}>
          {operation?.note}
        </Label>
      </div> */}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
            storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};

export const TreatmentDetail = ({
  operation,
  register,
  users,
  tanks,
  lots,
  errors,
  treatments,
  configs,
  user_id,
  dispatch,
  setValue,
  getValues,
  axiosPrivate,
  userSockets,
  addChatNote,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [completedState, setCompletedState] = useState([]);

  const setCheckboxState = (tank_id) => {
    const newCompletedState = [...completedState];
    const index = newCompletedState.indexOf(tank_id);
    if (index === -1) {
      newCompletedState.push(tank_id);
    } else {
      newCompletedState.splice(index, 1);
    }
    setCompletedState(newCompletedState);
  };
  const isBatchTreatment = operation?.on_tank === false;
  const [drugsData, setDrugsData] = useState([]);
  const [isShowCost, setIsShowCost] = useState(false);

  const computeTotalProductToAdd = (drug, liters) => {
    const productName =  drug?.substance_name || null;
    const productQuantity =  Number(drug?.quantity) || 0;
    const unit_id = drug?.unit_id || null;
    if (liters === 0 || productQuantity === 0 || unit_id === null || productName === null) return false;

    let totalProductToAdd = 0;
    switch (unit_id) {
      case 1: // mg/L
        const tmpQuantity1  = parseFloat(liters * productQuantity);
        if (tmpQuantity1 >= 1000 * 1000) totalProductToAdd = parseFloat(tmpQuantity1 / 1000 / 1000).toFixed(2) + " Kg";
        else if (tmpQuantity1 >= 1000) totalProductToAdd = parseFloat(tmpQuantity1 / 1000).toFixed(2) + " g";
        else totalProductToAdd = tmpQuantity1.toFixed(2) + " mg";  
        break;
      case 2: // g/hL
        const tmpQuantity2  = parseFloat((liters / 100) * productQuantity) ;
        if (tmpQuantity2 >= 1000) totalProductToAdd = parseFloat(tmpQuantity2 / 1000).toFixed(2) + " Kg";
        else totalProductToAdd = parseFloat(tmpQuantity2).toFixed(2) + " g";
        break;
        case 3: // L
          break;
        case 4: // Kg
          break;
        case 5: // " "
          break;
          case 6: // g/L
          break;
        case 7: // g/100Kg
          const tmpQuantity7  = parseFloat((liters / 100) * productQuantity) ;
          if (tmpQuantity7 >= 1000) totalProductToAdd = parseFloat(tmpQuantity7 / 1000).toFixed(2) + " Kg";
          else totalProductToAdd = parseFloat(tmpQuantity7).toFixed(2) + " g";
          break;
        case 8: // NTU
        totalProductToAdd =
          parseFloat((liters) * productQuantity).toFixed(2) + " NTU";
          break;
        case 9: // %Vol.
        totalProductToAdd =
          parseFloat((liters) * productQuantity).toFixed(2) + " %Vol.";
          break;
        case 10: // uS/DIT
          totalProductToAdd =
            parseFloat((liters) * productQuantity).toFixed(2) + " uS/DIT";
          break;
      default:
        break;
    }
    return totalProductToAdd;
  }

  const renderTotal = (tank_id) => {
    const mainSrc = operation?.src_tanks?.[0] || null;
    if (mainSrc === null) return '';
    const liters = operation?.completion_date !== null ? operation?.src_tanks?.find((t) => t?.tank_id == tank_id)?.old_quantity : 
      (operation?.src_tanks?.find((t) => t?.tank_id == tank_id)?.preOperation?.tank?.quantity || 
      (tanks?.find((t) => Number(t.id) === Number(tank_id)))?.quantity) || 0;
      
    const totalDrugs = [];
    let totalCostPerTank = 0;
    
    operation?.treatments?.filter(t => t?.tank_id === tank_id)?.forEach((drug) => {    
      const productName =  drug?.substance_name || null;
      const totalProductToAdd = computeTotalProductToAdd(drug, liters);

      if (totalProductToAdd) {
        const cost = parseFloat(Number(drug?.drug_batch_cost)) || null;
        totalDrugs.push(
          {
            quantity: totalProductToAdd,
            substance_name: productName,
            cost: cost || "-",
          });
          if (Number(cost) > 0) totalCostPerTank += parseFloat((Number(cost) * parseFloat(totalProductToAdd)));
        }
    });
    
    return (<div className="total_drug_wrapper">
      <div className="total_drug">
        {getLabel("drugTotal")}{" "}
        <ul>
          {totalDrugs?.map((totalDrug, index) => {return <li  key={`total_drug_${index}`} className="total_drug_quantity">
            <span className="substance_quantity">{totalDrug?.quantity}</span>
            <span className="substance_name">{totalDrug?.substance_name}</span>
            {index === totalDrugs?.length - 1 ? '' : ''}
          </li>})}
        </ul>
      </div>
      {isShowCost && <div className="total_drug_wrapper">
          <div className="total_drug">
            {getLabel("drugTankCosts")} {Number(totalCostPerTank) > 0 ? ` (${parseFloat(totalCostPerTank).toFixed(2)} €)` : ""}
            <ul>
              {totalDrugs?.map((totalDrug, index) => {return <li  key={`total_drug_cost_${index}`} className="total_drug_cost">
                <span>{Number(totalDrug?.cost) > 0 ? parseFloat((Number(totalDrug?.cost) * parseFloat(totalDrug?.quantity))).toFixed(2) : "-"} {totalDrug?.cost > 0 ? "€" : ""}</span>
                </li>})}
            </ul>
          </div>
      </div>}
    </div>
    );
  };
  
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor("substance_name", {
      header: getLabel("treatmentName"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,
      }
    }),
    columnHelper.accessor((row) => `${row?.quantity} ${row?.unit || ""}`, {
      header: getLabel("quantity"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,
      },
    }),
    // columnHelper.accessor("unit", {
    //   header: getLabel("unit"),
    //   cell: TableCell,
    // }),
    columnHelper.accessor(
      (row) => (row?.type ? getLabel(`drugType_${row.type?.toUpperCase()}`) : ""),
      {
        header: getLabel("drugType"),
        cell: TableCell,
        meta: {
          type: "text",
          isFilterDisabled: true,
          filterVariant: 'text',
        },
      }
    ),
    // columnHelper.accessor(
    //   (row) =>
    //     parseInt(row?.min_range) >= 0 && parseInt(row?.max_range) >= 0
    //       ? `${String(row?.min_range) || "0"} - ${
    //           String(row?.max_range) || ""
    //         } ${row?.unit}`
    //       : "",
    //   {
    //     header: getLabel("substanceRange"),
    //     cell: TableCell,
    //     meta: {
    //       type: "number",
    //       isFilterDisabled: true,
    //     },
    //   }
    // ),
    columnHelper.accessor(
      (row) =>
        `${
          row?.min_temperature ? String(row?.min_temperature) : "n/a"
        } - ${
          row?.max_temperature ? String(row?.max_temperature) : "n/a"
        } \u00b0C` || '',
      {
        header: getLabel("substanceTemperature"),
        cell: TableCell,
        meta: {
          type: "number",
          isFilterDisabled: true,
        },
      }
    ),
    columnHelper.accessor("drug_batch_number",
      {
        header: getLabel("drugBatchNumber"),
        cell: TableCell,
        meta: {
          isFilterDisabled: true,
        },
      }
    ),
  ];

  if (isShowCost) {
    columns.push(
      columnHelper.accessor((row) => `${row?.drug_batch_cost ? parseFloat((Number(row?.drug_batch_cost) * Number(row?.total_quantity))).toFixed(2) : ''} ${row?.drug_batch_cost ? "€" : ""}`,
      {
        header: getLabel("drugBatchProductCost"),
        cell: TableCell,
        meta: {
          isFilterDisabled: true,
        },
      }
    ),
    );
  }

  useEffect(() => {
    const tmp = [];
    const liters = operation?.src_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.old_quantity) || 0);
    }, 0) || 0;

    treatments?.drugs?.sort((a, b) => a?.substance_id - b?.substance_id)?.forEach((treatment) => {
      const newQuantity = operation?.treatments?.find(
        (o) => o?.substance_id == treatment?.substance_id
      )?.quantity;

      const total_quantity = computeTotalProductToAdd(treatment, liters);
      
      tmp.push({ ...treatment, quantity: newQuantity || treatment?.quantity, total_quantity: parseFloat(total_quantity) });
    });

    setDrugsData(tmp);
  }, [treatments, operation]);

  return (
    <>
      <h4>{getLabel("operationConfig")}</h4>
      <div className="operation_info_container_row">
      <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={operation?.completion_date === null ? getLabel("insertionDate") : getLabel("operationCompletionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            operation?.completion_date === null ? configs.shortDateFormat : configs.dateFormat
          )}
        </Label>
        <Label label={getLabel("expireDate")}>
          {format(
            new Date(operation?.expire_date || null),
            configs.shortDateFormat
          )}
        </Label>
        <Label label={getLabel("cellarman")}>
          {
            <div className="cellarman_container">
              {operation?.cellarman_ids?.map((cellarman, index) => {
                const cellarmanName =
                  users?.find?.((user) => Number(user.id) === Number(cellarman))
                    ?.username || "";
                return (
                  <div key={`cellarman-${index}`}>
                    {cellarmanName +
                      (operation?.cellarman_ids?.length > 1 ? " " : "")}
                  </div>
                );
              })}
            </div>
          }
        </Label>
      </div>
      <h4>{getLabel("treatmentProtocols")}</h4>
      <div className="operation_info_container_row">
        <Label label={getLabel("protocolName")}>
          {treatments?.protocols_name}
        </Label>
      </div>
      {/* <h3>{getLabel(`tanksInvolved`)}</h3>
        {operation?.src_tanks?.map((srcTanks) => {
            return <div className="operation_info_container_row">
                <tanksDetails
                    key={`src-${srcTanks.id}`}
                    tank={tanks.find((tank) => Number(tank.id) === Number(srcTanks?.tank_id))}
                    operation={operation}
                ></tanksDetails>
            </div>
        })} */}
      <div className="operation_info_container_row">
        <div className="analysis_table">
          {/* <Table data={drugsData} customColumns={columns} /> */}
          <TableEdit
            defaultData={drugsData}
            columns={columns}
            isSearchBar={false}
            type={isShowCost ? "treatmentApplication" : role === ROLES.USER ? "treatmentApplicationUser" : "treatment"}
            isLegend={false}
            // isEditable={role === ROLES.USER}
          />
        </div>
      </div>
      {!isBatchTreatment && (
        <>
          <div className="operation_info_container_title">
            <h4>{getLabel("fromTanksAnalysis")}</h4>
            {(role === 2 ||
              (role === ROLES.USER &&
                users?.filter((u) => u?.type === "USER")?.length ===
                  0)) && <CTA customClassName={!isShowCost ? "add" : "complete"} onClick={() => setIsShowCost(!isShowCost)}>
              {getLabel(isShowCost ? "fromTanksAnalysisHideCost" : "fromTanksAnalysisShowCost")}
            </CTA>}
          </div>
          {operation?.src_tanks?.map((srcTank, index) => {
            return (
              <div
                className="operation_info_container_row"
                key={`tank-row-${index}`}
              >
                <SrcTankDetail
                    key={`src-tr-${srcTank?.tank_id}`}
                    tank={srcTank}
                    isCurrentStateOnly={true}
                    totalDrug={renderTotal(srcTank?.tank_id)}
                  ></SrcTankDetail>
                {operation?.completion_date === null &&
                  (role === 3 ||
                    (role === ROLES.CLIENT &&
                      users?.filter((u) => u?.type === "USER")?.length ===
                        0)) && (
                    <>
                      <Input
                        name={`completed.${srcTank.tank_id}`}
                        register={register}
                        error={errors[`completed.${srcTank.tank_id}`]}
                        required={getLabel("inputRequiredError")}
                        isLabel={false}
                        type={"checkbox"}
                        checked={completedState.includes(srcTank.tank_id)}
                        onChange={() => setCheckboxState(srcTank.tank_id)}
                        customClassName={'confirm'}
                      />
                    </>
                  )}
              </div>
            );
          })}
        </>
      )}
      {isBatchTreatment && (
        <>
          <h3>{getLabel("fromLotsAnalysis")}</h3>
          {operation?.src_tanks?.map((srcTanks, index) => {
            return (
              <div
                className="operation_info_container_row"
                key={`tank-row-${index}`}
              >
                <BatchDetail
                  key={`src-${srcTanks.id}`}
                  lot={lots.find(
                    (lot) => Number(lot.id) === Number(srcTanks?.batch_id)
                  )}
                ></BatchDetail>
              </div>
            );
          })}
        </>
      )}
      {/* <div className="operation_info_container_row">
        <Label label={getLabel("operationNotes")} width={400} height={150} customClassName={"notes"}>
          {operation?.notes}
        </Label>
      </div> */}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
            storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};

export const CutDetail = ({
  operation,
  users,
  tanks,
  configs,
  getValues,
  register,
  errors,
  type,
  dispatch,
  setValue,
  user_id,
  axiosPrivate,
  userSockets,
  isMobile,
  addChatNote,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [completedState, setCompletedState] = useState([]);

  const setCheckboxState = (tank_id) => {
    const newCompletedState = [...completedState];
    const index = newCompletedState.indexOf(tank_id);
    if (index === -1) {
      newCompletedState.push(tank_id);
    } else {
      newCompletedState.splice(index, 1);
    }
    setCompletedState(newCompletedState);
  };

  const getTankData = (tank, isSrc = false) => {
    if (operation?.completion_date === null) {
      const t = tanks?.find((t) => t?.id === tank?.tank_id) || {};
      const tankList = (isSrc ? operation?.src_tanks : operation?.dest_tanks) || [];
      
      if (type !== 'CUT') {
        const destTank = isSrc ? {} : tankList?.find((tt) => tt?.tank_id === t?.id);
        const arrow_quantity = !isSrc ? destTank?.quantity :
        operation?.dest_tanks?.reduce((acc, curr) => {
          return acc + (Number(curr?.quantity) || 0);
        }, 0);
        const newQuantity = t?.quantity + (isSrc ? -arrow_quantity : arrow_quantity);

        return {...t, ...(!isSrc && type === 'RACKING' && { batch_type: destTank?.batch_type }), ...(!isSrc && { batch_name: destTank?.new_batch_name }), old_batch_name: t?.batch_name, old_quantity: t?.quantity, quantity: newQuantity, arrow_quantity: arrow_quantity };
      } else {
        const destTank = !isSrc ? {} : tankList?.find((tt) => tt?.tank_id === t?.id);
        const arrow_quantity = isSrc ? destTank?.quantity :
        operation?.src_tanks?.reduce((acc, curr) => {
          return acc + (Number(curr?.quantity) || 0);
        }, 0);
        const newQuantity = t?.quantity + (isSrc ? -destTank?.quantity : arrow_quantity);

        return {...t, ...(!isSrc && { batch_name: tankList?.find((tt) => tt?.tank_id === t?.id)?.new_batch_name, color: tanks?.find((t) => t?.id === operation?.src_tanks?.[0]?.tank_id)?.color }), old_batch_name: t?.batch_name, old_quantity: t?.quantity, quantity: newQuantity, arrow_quantity: arrow_quantity };  
      }
    } else {
      const tankData = tank?.postOperation?.tank || null;
      const color = tank?.color || tank?.postOperation?.batch?.color || null;
      const old_batch_name = tank?.postOperation?.batch?.name || '';
      
      return {...tankData, ...(!isSrc && type === 'RACKING' && { batch_type: tank?.batch_type }), color: color, old_batch_name: old_batch_name };
    }
  };
  
  const onNewScanResult = (decodedText, decodedResult) => {
    // handle decoded results here
    console.log('scanned', decodedText, decodedResult)
  };

  const renderPomaces = () => {

    // 100 L of fresh pomace (density ≈ 0.4 kg/L)   --> 40 Kg
    // 100 L of partially dried pomace (~0.55 kg/L) --> 55 Kg
    // 100 L of dry pomace (~0.8 kg/L)              --> 80 Kg
    
    const totalPomaces = operation?.dest_tanks?.reduce((sum, src) => sum + (parseFloat(src?.drop) || 0), 0) * 0.4;
    if (totalPomaces > 0 && operation?.pomaces)
    return (<Label label={getLabel("operationPomacesDestinationPlaceholder")}>
      {operation?.pomaces || ''} {`(${totalPomaces === 100 ? 1 : totalPomaces > 100 ? parseFloat(totalPomaces / 100, 2).toFixed(2) : totalPomaces } ${totalPomaces > 200 ? getLabel("operationPomaces100Kgs") : totalPomaces >= 100 ? getLabel("operationPomaces100Kg") : 'Kg'})`}
    </Label>);

    return;
  }
  
  return (
    <>
      {/* <h3>{getLabel(`operationType${operation?.type}`)}</h3> */}
      <div className={`operation_info_container_row ${operation?.cellarman_ids?.length > 1 ? 'start' : ''}`}>
        <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={getLabel("insertionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            configs.shortDateFormat
          )}
        </Label>
        {operation?.completion_date === null && <Label label={getLabel("expireDate")}>
          {format(
            new Date(operation?.expire_date || null),
            configs.shortDateFormat
          )}
        </Label>}
        {operation?.completion_date && (
          <>
            <Label label={getLabel("operationCompletionUser")}>
              <div>
                {users?.find?.(
                  (user) => Number(user.id) === Number(operation?.completed_by)
                )?.username || ""}
              </div>
            </Label>
            <Label label={getLabel("operationCompletionDate")}>
              {format(
                new Date(operation?.completion_date || null),
                configs.dateFormat
              )}
            </Label>
          </>
        )}
        {/* <Label label={getLabel("cellarman")}>
          {
            <div className="cellarman_container">
              {operation?.cellarman_ids?.map((cellarman) => {
                const cellarmanName =
                  users?.find?.((user) => Number(user.id) === Number(cellarman))
                    ?.username || "";
                return (
                  <div>
                    {cellarmanName +
                      (operation?.cellarman_ids?.length > 1 ? " " : "")}
                  </div>
                );
              })}
            </div>
          }
        </Label> */}
      </div>
      <div className={"confirmation-modal-container"}>
        <h4>{getLabel("operationDetail")}</h4>
        <OperationRecap
          type={type}
          isScale={false}
          // src_tanks={getRecapTanks(tanks, operation, true)}
          // dest_tanks={getRecapTanks(tanks, operation, false)}
          src_tanks={operation?.src_tanks}
          dest_tanks={operation?.dest_tanks?.map(d => { return { ...d, add_quantity: d?.quantity }})}
        />
      </div>
      {/* <h3>{getLabel("fromTanks")}</h3> */}
      <h4>{type === "CUT" ? getLabel("fromTanks") : getLabel("fromTank")}</h4>
      {operation?.src_tanks?.filter((s, index) => type === "CUT" ? true : index === 0)?.map((srcTank, index) => { // trick to avoid multiple src tanks
        return (
          <div className="operation_info_container_row" key={index}>
            <SrcTankDetail
              key={`src-${srcTank.id || index}`}
              // tank={getTankData(srcTans, true)}
              // tank={srcTank}
              tank={actualizeSrcTank(operation?.type, operation?.completion_date, srcTank, tanks, true)}
              operation={operation}
            ></SrcTankDetail>
          </div>
        );
      })}
      {/* <h3>{getLabel("toTank")}</h3> */}
      <h4>{type === "CUT" || operation?.dest_tanks?.length === 1 ? getLabel("toTank") : getLabel("toTanks")}</h4>
      {operation?.dest_tanks?.map((destTank, index) => {
        return (
          <div className="operation_info_container_row">
            <DestTankDetail
              key={`dest-${destTank?.id || index}`}
              // tank={getTankData(destTank)}
              tank={destTank}
              data={destTank}
              operation={operation}
              isMobile={isMobile}
            ></DestTankDetail>
            {role === 3 && operation.completion_date == null && (
              <div className="inputs_wrapper">
                <Input
                  name={`completed.${destTank.tank_id}`}
                  register={register}
                  error={errors[`completed.${destTank.tank_id}`]}
                  required={getLabel("inputRequiredError")}
                  type={"checkbox"}
                  isLabel={false}
                  checked={completedState.includes(destTank.tank_id)}
                  onChange={() => setCheckboxState(destTank.tank_id)}
                  customClassName={'confirm'}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                      setCheckboxState(destTank.tank_id); // Change the checkbox state
                      setValue(`completed.${destTank.tank_id}`, !completedState.includes(destTank.tank_id));
                    }
                  }}
                />
                {/* <QRcodeReader
                    // fps={10}
                    // qrbox={250}
                    // disableFlip={false}
                    // qrCodeSuccessCallback={onNewScanResult}
                />      */}
                {getValues(`completed.${destTank.tank_id}`) && (
                  <Input
                    name={`drop.${destTank.tank_id}`}
                    label={getLabel("operationDrop")}
                    placeholder={getLabel("operationDropPlaceholder")}
                    register={register}
                    error={errors[`drop`]?.[destTank.tank_id]}
                    // required={getLabel("inputRequiredError")}
                    type={"number"}
                    defaultValue={0}
                    min={{
                      value: 0,
                      message: getLabel("errorMinValue", { value: "0" }),
                    }}
                    max={{
                      value:
                        type === "CUT"
                          ? operation.src_tanks?.reduce(
                              (acc, cur) => Number(acc) + Number(cur.quantity),
                              0
                            ) - 1
                          : Number(destTank.quantity) - 1, // TO DO: aggiustare coefficiente
                      message: getLabel("errorMaxValue", {
                        value:
                          type === "CUT"
                            ? operation.src_tanks?.reduce(
                                (acc, cur) =>
                                  Number(acc) + Number(cur.quantity),
                                0
                              ) - 1
                            : Number(destTank.quantity) - 1,
                      }),
                    }}
                    // Math.max(0, Number(destTank.quantity)),
                  />
                )}
              </div>
            )}
          </div>
        );
      })}
      {/* <div className="operation_info_container_row">
        <Label label={getLabel("operationNotes")} width={400} height={150} customClassName={"notes"}>
          {operation?.note}
        </Label>
      </div> */}
      {operation?.type === 'RACKING' && operation?.pomaces?.length > 0 && operation?.dest_tanks?.reduce((sum, src) => sum + (parseFloat(src?.drop) || 0), 0) > 0 && <>
      <h4>{getLabel("operationPomaces")}</h4>
      <div className="operation_info_container_row">
        {renderPomaces()}
      </div></>}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
            storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};

export const AnalysisDetail = ({
  operation,
  users,
  tanks,
  lots,
  analysis,
  results,
  configs,
  isCellarmanEnabled,
  registerComplete,
  errorsComplete,
  controlComplete,
  analysisState,
  getValues,
  dispatch,
  user_id,
  setValue,
  register,
  axiosPrivate,
  userSockets,
  addChatNote,
  isMobile,
}) => {
  const [getLabel] = useLabels();
  const [data, setData] = useState([]);
  const [minEditableIndex, setMinEditableIndex] = useState(0);
  const [maxEditableIndex, setMaxEditableIndex] = useState(0);

  const displayModeGrid = useSelector(selectAnalysisDisplayGrid);

  const isBatchAnalysis = !operation?.on_tank;
  const isCompleted =
    (!operation?.repetitive &&
      operation?.completion_date !== undefined &&
      operation?.completion_date !== null) ||
    (operation?.repetitive &&
      Number(operation?.completed) === Number(operation?.total));

    // useEffect(() => {
    //   const tmpData = [];
      
    //   if (!isCompleted && operation?.repetitive) {
    //     if (Number(operation?.completed) > 0) {
    //       setCompletedAnalysisData(tmpData);
    //     }
    //     if (Number(operation?.completed) < Number(operation?.total))
    //       setUncompletedAnalysisData(tmpData);
    //   } else if (isCompleted) setCompletedAnalysisData(tmpData);
    //   else setUncompletedAnalysisData(tmpData);
    
    //   // setData(tmpData);
    // }, [results, analysis]);

  useEffect(() => {
    const tmp = [];
    
    // console.log('results', results)
    // console.log('analysis', analysis)
    const analysisArray = [...operation?.treatments || []];
    const processedTanks = new Set();
    // console.log('analysisArray', analysisArray)
    
    analysisArray
      ?.sort((a, b) => a?.tank_id - b?.tank_id)
      ?.forEach((an, i) => {
        const source = operation?.on_tank
          ? tanks?.find((t) => t.id == an?.tank_id)
          : lots?.find((l) => l.id == an?.batch_id);
        const index = tmp?.findIndex((t) => t?.substance_name === an?.substance_name && t.tank_id == an?.tank_id);
        if (index > -1) {
          const items = tmp[index].items;
          items.push({ unit: an?.unit, min_range: an?.min_range, max_range: an?.max_range, colors: ["ROSE"]});
          tmp[index].items = items
          return true;
        }
        const isTankFirst = !processedTanks.has(an?.tank_id || an?.batch_id);
        // console.log('an', an)
        tmp.push({
          ...an, 
          batch_name: source?.batch_name,
          isTankFirst: isTankFirst, // true only if not already processed
          collection_date: isTankFirst ? an?.collection_date : null,
          user_id: isTankFirst ? an?.user_id : null,
          src_name: isTankFirst ? source?.name : null,
          temperature: an?.temperature,
          enableRange: i < analysis?.analysis?.length,
          isShowFirstLineData: isTankFirst, //obj.isTankFirst,    // TO DO, if ok remove isShowFirstLineData and use isTankFirst i % rowCount === 0;
          // relative_id = Math.floor(tmpData?.length / (tanksLen * anLen)) + 1;
          // endOfRepBorder: true,// i % rowCount === 0,
          endOfSrcNameBorder: isTankFirst,
          opType: "ANALYSIS",
          items: [{ unit: an?.unit, min_range: an?.min_range, max_range: an?.max_range, colors: ["RED"]}],
        });
        
        processedTanks.add(an?.tank_id || an?.batch_id); // mark this tank_id (or batch_id) as processed
      });

      setData(tmp);
      // setData(getFilteredSubstances(analysisArray));
      if (!operation?.repetitive) {
        setMinEditableIndex(0);
        setMaxEditableIndex(tmp?.length);
      }
      // console.log('tmp', tmp)
  }, [operation, analysis]);


  const getFilteredSubstances = (substances = [], importDataState = null) => {
  
    const tmp = [];

    // Grouping function
    const grouped = substances
      ?.filter((s) => importDataState !== null ? s?.states?.includes(importDataState) : true)
      ?.reduce((acc, item) => {
        const key = item.substance_name || item.name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        
        return acc;
      }, {});
      console.log('grouped', grouped)
    // Convert the result to an array of grouped objects (optional)
    Object.keys(grouped)?.forEach((key) => {
      const items = grouped[key];
      const firstItem = items?.[0];
      const substance_name = getLabel(`substance_${key}`);
      // console.log('grouped key', grouped[key])

      tmp.push({
        name: key,
        substance_name: key,
        substance_name_lower: substance_name?.toLowerCase(),
        unit: firstItem?.unit,
        unit_id: firstItem?.unit_id,
        // unit: firstItem?.unit,
        id: firstItem?.id,
        value: firstItem?.id,
        label: substance_name,
        batch_name: items?.batch_name,
        src_name: items?.src_name, 
        items: items,
        states: firstItem?.states,
        opType: "ANALYSIS",
      });
    });
    console.log('mp', tmp)

    return tmp?.sort((a, b) =>
      a?.substance_name_lower > b?.substance_name_lower
        ? 1
        : b?.substance_name_lower > a?.substance_name_lower
        ? -1
        : 0
    );
  };

  // const setCompletedAnalysisData = (tmpData) => {
  //   if (!results || results?.length === 0 || !results?.[0]?.results) return;
  //   let isShowFirstLineData = true;
  //   const keys = analysis?.analysis?.map((an) => an?.substance_name) || []; // Object.keys(result?.results);
  //   const len = keys.length || 0;

  //   const anLen = countUniqueAnalysis();
  //   const tanksLen = operation?.src_tanks?.length;
  //   const rowsNum = anLen * tanksLen;

  //   results?.forEach((result, i) => {
  //     const res = result?.results;

  //     // if (!result?.results) return true;
  //     for (let index = 0; index < anLen; index++) {
  //       const currentAnalysis = analysis?.analysis?.find(
  //         (a) => a.substance_id === res?.[index]?.substance_id
  //       );

  //       const name = currentAnalysis?.name || "";
  //       const batch_name = operation?.src_tanks?.find(o => (o?.tank_id || o?.batch_id) === res?.[index]?.tank_id)?.name || "";
  //       const value = res?.[index]?.value || "";
  //       // const currentAnalysis = analysis?.analysis
  //       const completedRowsNum = Number(operation?.completed) * rowsNum;
  //       const totalIndex = i * (len || 0) + index;
  //       tmpData.push({
  //         ...result,
  //         batch_name: batch_name,
  //         results: value,
  //         name: name,
  //         isShowFirstLineData:
  //           totalIndex %
  //             (rowsNum) ===
  //           0,
  //         enableRange: i === 0 || totalIndex >= completedRowsNum && totalIndex < (anLen + completedRowsNum),
  //         min_range: currentAnalysis?.min_range,
  //         max_range: currentAnalysis?.max_range,
  //         src_name:
  //           (operation?.on_tank
  //             ? tanks?.find((t) => t.id == result?.tank_id)?.name
  //             : lots?.find((l) => l.id == result?.batch_id)?.name) || "",
  //         repetitive: operation?.repetitive,
  //         unit: currentAnalysis?.unit || "",
  //         endOfRepBorder: operation?.repetitive
  //           ? !isShowFirstLineData &&
  //             totalIndex %
  //               rowsNum === 0
  //           : false,
  //         // i % operation?.src_tanks?.length === 0 && !isShowFirstLineData,
  //         // endOfSrcNameBorder: !isShowFirstLineData && totalIndex % operation?.src_tanks?.length === 0,
  //         endOfSrcNameBorder:
  //           !isShowFirstLineData &&
  //           totalIndex % anLen === 0,
  //         isTankFirst: index % anLen === 0,
  //         opType: "ANALYSIS",
  //       });
  //       isShowFirstLineData = false;
  //     }

  //     // for (let index = 0; index < len; index++) {
  //     //   const currentAnalysis = analysis?.analysis?.find(
  //     //     (a) => a.substance_name === keys[index]
  //     //   );
  //     //   const completedRowsNum = Number(operation?.completed) * rowsNum;
  //     //   const totalIndex = i * (len || 0) + index;
  //     //   tmpData.push({
  //     //     ...result,
  //     //     results: result?.results?.[keys[index]] || "",
  //     //     name: keys[index],
  //     //     isShowFirstLineData:
  //     //       totalIndex %
  //     //         (rowsNum) ===
  //     //       0,
  //     //     enableRange: i === 0 || totalIndex >= completedRowsNum && totalIndex < (anLen + completedRowsNum),
  //     //     min_range: currentAnalysis?.min_range,
  //     //     max_range: currentAnalysis?.max_range,
  //     //     src_name:
  //     //       (operation?.on_tank
  //     //         ? tanks?.find((t) => t.id == result?.tank_id)?.name
  //     //         : lots?.find((l) => l.id == result?.batch_id)?.name) || "",
  //     //     repetitive: operation?.repetitive,
  //     //     unit: currentAnalysis?.unit || "",
  //     //     endOfRepBorder: operation?.repetitive
  //     //       ? !isShowFirstLineData &&
  //     //         totalIndex %
  //     //           rowsNum === 0
  //     //       : false,
  //     //     // i % operation?.src_tanks?.length === 0 && !isShowFirstLineData,
  //     //     // endOfSrcNameBorder: !isShowFirstLineData && totalIndex % operation?.src_tanks?.length === 0,
  //     //     endOfSrcNameBorder:
  //     //       !isShowFirstLineData &&
  //     //       totalIndex % anLen === 0,
  //     //     isTankFirst: index % anLen === 0,
  //     //     opType: "ANALYSIS",
  //     //   });
  //     //   isShowFirstLineData = false;
  //     // }
  //   });
  // };

  // const populateBaseData = (tmp, result, an) => {
  //   const source = operation?.on_tank
  //     ? tanks?.find((t) => t.id == result?.tank_id)
  //     : lots?.find((l) => l.id == result?.batch_id);

  //   const color = source?.color ? `(${getLabel(`lotColor_${source?.color}`)})` : "";

  //   const ranges = {
  //     min_range: an?.min_range,
  //     max_range: an?.max_range
  //   };

  //   tmp.push({
  //     name: an?.substance_name,
  //     color: color,
  //     substance_id: `${an?.substance_id}`,
  //     unit: an?.unit,
  //     enableRange: Number(operation?.completed) === 0,
  //     ...ranges,
  //     src_name: source?.name || "",
  //     batch_name: source?.batch_name || "",
  //     src_id: source?.id || "",
  //     opType: "ANALYSIS",
  //   });
  // };

  // const countUniqueAnalysis = () => {
  //   return [...new Set(analysis?.analysis?.filter(a => !a?.removed || a?.removed === false)?.map(item => item?.substance_name))]?.length;
  // };

  // const setUncompletedAnalysisData = (tmpData) => {
  //   const tmp = [];
  //   if (results?.filter((an) => an?.result)?.length === 0 || tmpData?.length > 0) {
  //     operation?.src_tanks?.forEach((s) => {
  //     // for (const s of (operation?.src_tanks || [])) {
  //       const result = operation?.on_tank
  //         ? { tank_id: s.tank_id }
  //         : { batch_id: s.batch_id };
  //       const customAnalysisIds = operation?.treatments
  //         ?.filter((t) => t?.valid_tanks?.includes(Number(s?.tank_id) || s?.batch_id) && (!t?.removed || t?.removed === false))
  //         ?.map(s => s?.substance_id) || [];
  //       const customAnalysisPerTank = analysis?.analysis?.filter((a) => customAnalysisIds?.includes(a?.substance_id)) || [];

  //       customAnalysisPerTank?.forEach((an) => {
  //         populateBaseData(tmp, result, an);
  //       });
  //     }
  //     );
  //   }

  //   const anLen = countUniqueAnalysis();
  //   const tanksLen = operation?.src_tanks?.length;
  //   const rowCount =
  //     anLen * operation?.src_tanks?.length || 1;
  //   const analysisCount = anLen;
  //   const sampledCount =  tmpData?.length > 0 ?
  //     Number(operation?.total) - Number(tmpData?.length / rowCount) || 0 : 0;
  //   const missingReplica = operation?.repetitive
  //     ? Number(operation?.total) -
  //       Number(operation?.completed) -
  //       sampledCount -
  //       1
  //     : 0;
  //   // console.log('rowCount', rowCount, 'analysisCount', analysisCount, 'sampledCount', sampledCount)

  //   if (missingReplica > 0) {
  //     const copy = [...tmp];
  //     for (let index = 0; index < missingReplica; index++) {
  //       tmp.push(...copy);
  //     }
  //   }
  //   const basicData = {
  //     total: operation?.total,
  //     repetitive: operation?.repetitive,
  //     // enableRange: false,
  //   };

  //   tmp?.forEach((t, i) => {
  //     const obj = { ...t, ...basicData };

  //     obj.isTankFirst = i % analysisCount === 0;
  //     // obj.isTankFirst =
  //     // i % rowCount === 0 ||
  //     // (operation?.src_tanks?.length > 1 &&
  //     //   i % operation?.src_tanks?.length === 0);
  //     obj.isShowFirstLineData = obj.isTankFirst;    // TO DO, if ok remove isShowFirstLineData and use isTankFirst i % rowCount === 0;
  //     obj.relative_id = Math.floor(tmpData?.length / (tanksLen * anLen)) + 1;
  //     obj.endOfRepBorder = i % rowCount === 0;
  //     obj.endOfSrcNameBorder = obj.isTankFirst;
  //     // obj.endOfSrcNameBorder =
  //     //   operation?.src_tanks?.length === 1
  //     //     ? false
  //     //     : i % operation?.src_tanks?.length === 0 && i > 0;
  //     // obj.enableRange = true;
  //     // console.log('i', i, anLen * ta)
  //     obj.enableRange =
  //       i < (tanksLen * anLen) && Number(operation?.completed) === 0;
  //     obj.isEditable =
  //       Number(operation?.relative_id) === Number(obj?.relative_id);
  //     obj.opType = "ANALYSIS";

  //     const isOnlySampled = results?.filter((r) => r?.results === null)?.length > 0;
  //     if (obj.isShowFirstLineData && obj.isTankFirst && isOnlySampled) { //i === Number(operation?.completed) && isOnlySampled) {
  //       // only sampled
  //       const sample = results?.find((r) => r?.tank_id === t?.src_id);
  //       obj.collection_date = new Date(sample?.collection_date);
  //       obj.temperature = sample?.temperature;
  //       obj.user_id = sample?.user_id;
  //     }
  
  //     if (
  //       Number(obj.relative_id) <= Number(operation.total) ||
  //       !operation?.repetitive
  //     )
  //       tmpData.push(obj);
  //   });
  // };

  const columnHelper = createColumnHelper();
  const columns = [
    // columnHelper.accessor((row) => `${row?.isTankFirst ? row.src_name : ""}`, {
    columnHelper.accessor("src_name", {
      header: operation?.on_tank ? getLabel("tank") : getLabel("lot"),
      cell: TableCell,
      meta: {
        filterVariant: 'text',
        customClassName: 'hide',
      },
    }),
    columnHelper.accessor("batch_name", {
      header: getLabel("lot"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,   // TO DO: fix search not working
        customClassName: 'hide',
      },
    }),
  ];

  if (operation?.repetitive) {
    columns.unshift(
      columnHelper.accessor(
        (row) =>
          `${row?.isShowFirstLineData ? row.relative_id : ""}${
            row?.isShowFirstLineData ? "/" + row?.total : ""
          }`,
        {
          header: getLabel("analysisRepetition"),
          cell: TableCell,
          meta: {
            isFilterDisabled: true,
          }
        }
      )
    );
  }

  // if (!isCompleted) {
  // columns.push(
    
    // columnHelper.accessor("quantity", {
    //   header: getLabel("examResult"),
    //   cell: TableCell,
    //   meta: {
    //     type: "number",
    //     editable: true,
    //     regExpPattern: INT_FLOAT_REGEX,
    //     register: registerComplete,
    //   },
    // })
  // );
  // }
  // if (isCellarmanEnabled && Number(operation?.completed) < Number(operation?.total)) {
   
  if (analysisState !== 'NOT_SAMPLED') {
    columns.push(          
      columnHelper.accessor(
        (row) =>
          !row?.isShowFirstLineData
            ? ""
            : `${row?.collection_date
              ? format(new Date(row.collection_date || null), configs.hourMediumDateFormat) : ""} (${users?.find((u) => u.id === Number(row.user_id))?.username || "-"}) - ${row?.temperature
                ? row.temperature + " \u00b0C"
                : ""}`,
        {
          header: getLabel("analysisCollection"),
          cell: TableCell,
          meta: {
            isFilterDisabled: true,
          }
        }
      ));
    }
    
  //   if (analysisState !== 'NOT_SAMPLED') {
  //       columns.push(          
  //         columnHelper.accessor(
  //           (row) =>
  //             !row?.isShowFirstLineData
  //               ? ""
  //               : users?.find((u) => u.id === Number(row.user_id))?.username || "-",
  //           {
  //             header: getLabel("analysisCollectionUser"),
  //             cell: TableCell,
  //             meta: {
  //               isFilterDisabled: true,
  //             }
  //           }
  //         ),
          
  //     columnHelper.accessor(
  //       (row) => 
  //         !row?.isShowFirstLineData 
  //           ? ""
  //           : row?.collection_date
  //           ? format(new Date(row.collection_date || null), configs.dateFormat)
  //           : '',
  //       {
  //         header: getLabel("analysisCollectionDate"),
  //         cell: TableCell,
  //         meta: {
  //           isFilterDisabled: true,
  //         },
  //       }
  //     ),
  //     columnHelper.accessor(
  //       (row) =>
  //         `${
  //           row?.isTankFirst && row?.temperature
  //             ? row.temperature + " \u00b0C"
  //             : row?.isShowFirstLineData ? "-" : ""
  //         }`,
  //       {
  //         header: getLabel("analysisExamTemperature"),
  //         cell: TableCell,
  //         meta: {
  //           isFilterDisabled: true,
  //         },
  //       }
  //     )
  //   );
  // }

  columns.push(
    columnHelper.accessor((row) => getLabel(`substance_${row?.substance_name}`), {
      // + (row?.unit?.trim()?.length > 0 ? ` (${row.unit})` : ''), {
      header: getLabel("analysisName"),
      cell: TableCell,
      meta: {
        filterVariant: 'text',
      }
    }),
  );

  if (operation.type === "ANALYSIS") {
    columns.push(
      // columnHelper.accessor(
      //   (row) =>
      //     row?.enableRange || analysisState === "INSERTING"
      //       ?`${row?.min_range ? String(row?.min_range) : 'n/a'} - ${row?.max_range ? String(row?.max_range) : 'n/a'} ${row?.unit}`
      //       : "",
      //       {
      //     header: getLabel("substanceRange"),
      //     cell: TableCell,
      //     meta: {
      //       isFilterDisabled: true,
      //       additional: 'examColor'
      //     }
      //   }
      // ),
      columnHelper.accessor("ranges", {
        header:
          getLabel("substanceRange"),
          cell: MultipleRowsCell,
          meta: {
            array: "items",
            selector: "ranges",
            isFilterDisabled: true,
          },
      }),
    );
  }

  if (analysisState !== "NOT_SAMPLED" && (operation?.sampled || Number(operation?.completed) <= Number(operation?.total))) {
    columns.push(
      columnHelper.accessor((row) => (row?.results ? row.results + (row?.unit ? ` ${row?.unit}` : '') : ""), {
        header:
          operation.type === "ANALYSIS"
            ? getLabel("examResult")
            : getLabel("drugQuantity"),
        cell: TableCell,
        meta: {
          type: "number",
          editable: true,
          register: registerComplete,
          noStoreValue: true,
          isFilterDisabled: true,
          isCompleted: true,
        },
      })
    );
  }

  // TO DO: quando filtri per analisi o tank, la colonna # 1/4 scompare
  // if (analysisState && analysisState !== "NOT_SAMPLED") { //Number(operation?.completed) > 0) {
  //   columns.push(
  //     columnHelper.accessor(
  //       (row) => 
  //         !row?.isShowFirstLineData 
  //           ? ""
  //           : row?.collection_date
  //           ? format(new Date(row.collection_date || null), configs.dateFormat)
  //           : '-',
  //       {
  //         header: getLabel("analysisCollectionDate"),
  //         cell: TableCell,
  //         meta: {
  //           isFilterDisabled: true,
  //         },
  //       }
  //     ));
  // }
  if (Number(operation?.completed) > 0) {
    columns.push(
      columnHelper.accessor(
        (row) =>
          !row?.isShowFirstLineData ? "" : row?.analyst ? row.analyst : "-",
        {
          header: getLabel("analysisAnalyst"),
          cell: TableCell,
          meta: {
            isFilterDisabled: true,
          }
        }
      ));
  }

  //   if (isCellarmanEnabled && Number(operation?.completed) < Number(operation?.total)) {
  //     columns.push(
  //       columnHelper.display({
  //         id: "edit",
  //         cell: EditCell,
  //         meta: {
  //           isEditable: true,
  //         },
  //       }),
  //     );
  // }

  // if (isCellarmanEnabled) {

  //   // if (!isCompleted && Number(operation?.completed) === 0) {
  //   //   columns.push(
  //   //     columnHelper.accessor((row) => (!row?.enableRange ? "" : row?.unit), {
  //   //       header: getLabel("unit"),
  //   //       cell: TableCell,
  //   //     }),
  //   //   )
  //   // }

  // } else {
  //   columns.push(
  //     columnHelper.accessor(
  //       (row) =>
  //         !row?.isFirst
  //           ? ""
  //           : row?.results
  //           ? row.results + " " + row?.unit
  //           : "-",
  //       {
  //         header: getLabel("substanceResult"),
  //         cell: TableCell,
  //       }
  //     ),

  //   );
  // }

  const renderAnalysisEvolution = () => {
    return (
      <div>
        <div className="primary_container_menu">
          {/* <h4>{getLabel('nextOperations')}</h4> */}
        </div>
        {results?.length > 0 && (
          <AnalysisEvolution
            configs={configs}
            analysisResults={results}
            lots={[
              ...new Set(
                results
                  ?.map((r) =>
                    lots?.find((l) => l.id == r.batch_id && r.tank_id === null)
                  )
                  .filter(Boolean)
              ),
            ]}
            tanks={[
              ...new Set(
                results
                  ?.map((r) => tanks?.find((t) => t.id == r.tank_id))
                  .filter(Boolean)
              ),
            ]}
            exams={[analysis]?.filter((exam) =>
              [operation]?.find(
                (an) => Number(exam.protocols_id) === Number(an.protocol_id)
              )
            )}
          />
        )}
      </div>
    );
  };

  const getTankData = (tank) => {
    // const tankData = ((operation?.completion_date === null) ? tank?.preOperation?.tank : tank?.postOperation?.tank) || {};
    // const color = (((operation?.completion_date === null) ? tank?.preOperation?.batch : tank?.postOperation?.batch)?.color) || null;
    if (operation?.completion_date !== null) {
      const tankData = tank?.postOperation?.tank || {};
      const color = tank?.postOperation?.batch?.color || null;
      return {...tankData, color: color };
    } else {
      const t = tanks?.find((t) => t?.id === Number(tank?.tank_id));
      return {...t, old_batch_name: t?.batch_name, old_quantity: t?.quantity };
    }
  };
  
  const toggleDisplayMode = () => {
    dispatch(toggleAnalysisDisplayGrid())
  }
 
  return (
    <>
      {/* <h4>{getLabel("analysisProtocols")}</h4> */}
      <h4>{getLabel("operationConfig")}</h4>
      <div className="operation_info_container_row">
      <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={operation?.completion_date === null ? getLabel("insertionDate") : getLabel("operationCompletionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            operation?.completion_date === null ? configs.shortDateFormat : configs.dateFormat
          )}
        </Label>
        <Label label={getLabel("expireDate")}>
          {format(
            new Date(operation?.expire_date || null),
            configs.shortDateFormat
          )}
        </Label>
        <Label label={getLabel("cellarman")}>
          {
            <div className="cellarman_container">
              {operation?.cellarman_ids?.map((cellarman, index) => {
                const cellarmanName =
                  users?.find?.((user) => Number(user.id) === Number(cellarman))
                    ?.username || "";
                return (
                  <div key={`cellarman-${index}`}>
                    {cellarmanName +
                      (operation?.cellarman_ids?.length > 1 ? " " : "")}
                  </div>
                );
              })}
            </div>
          }
        </Label>
      </div>
      <div className="analysis_table">
      <h4>{getLabel("analysisProtocols")}</h4>
        <Label label={getLabel("protocolName")}>
          {analysis?.protocols_name}
        </Label>
      {/* </div> */}
        {/* <h4 className="analysis_title">{analysis?.protocols_name}</h4> */}
        <div className="analysis_switch">
        <Switch
          leftOption={{
              label: getLabel('listView')
          }}
          rightOption={{
              label: getLabel('gridView')
          }}
          toggleHandler={toggleDisplayMode}
          status={displayModeGrid}
        />
        <div>
          {data?.length > 0 && (
            <TableEdit
              defaultData={data}
              columns={columns}
              errors={errorsComplete}
              control={controlComplete}
              isEditable={true}
              isSorting={false}
              isMobile={displayModeGrid || isMobile}
              isSearchBar={false}
              analysisState={analysisState}
              filterType={"analysis"}
              minEditableIndex={minEditableIndex}
              maxEditableIndex={maxEditableIndex}
              newRow={{
                quantity: "",
              }}
              setValue={setValue}
              getValues={getValues}
              type={"analysisDetail"}
            />
          )}
        </div>
        </div>
      </div>
      {!isBatchAnalysis && (
        <>
          <h4>{getLabel("fromTanksAnalysis")}</h4>
          <div className="operation_info_container analysis_tanks">
            {operation?.src_tanks?.map((srcTank, index) => {
              return (
                <div
                  className="operation_info_container_row"
                  key={`dest-${index}`}
                >
                  <SrcTankDetail
                    key={`src-an-${srcTank.id}`}
                    // tank={getTankData(srcTank)}
                    tank={srcTank}
                    isCurrentStateOnly={true}
                  ></SrcTankDetail>
                  {/* <TankIcon
                  tank={operation?.completion_date !== null ? {  // TO DO: add ...(tanks.find())
                    name: tanks.find(
                      (tank) => Number(tank.id) === Number(srcTanks?.tank_id))?.name,
                    capacity: tanks.find(
                      (tank) => Number(tank.id) === Number(srcTanks?.tank_id))?.capacity,
                    quantity: tanks.find(
                      (tank) => Number(tank.id) === Number(srcTanks?.tank_id))?.quantity,
                    color: tanks.find(
                      (tank) => Number(tank.id) === Number(srcTanks?.tank_id))?.color
                  } : tanks.find(
                    (tank) => Number(tank.id) === Number(srcTanks?.tank_id)
                  )}
                  isText={false}
                  isReverse={true}
                  isRecap={false}
                  isName={true}
                  isBatchName={true}
                /> */}
                </div>
              );
            })}
          </div>
        </>
      )}
      {isBatchAnalysis && (
        <>
          <h4>{getLabel("fromLotsAnalysis")}</h4>
          <div className="operation_info_container_row">
            {operation?.src_tanks?.map((srcTanks, index) => {
              return (
                <BatchDetail
                  key={`src-${srcTanks.id}`}
                  lot={lots.find(
                    (lot) => Number(lot.id) === Number(srcTanks?.batch_id)
                  )}
                ></BatchDetail>
              );
            })}
          </div>
        </>
      )}
      {isCellarmanEnabled && (
        <div>
          {/* <Input
            name="temperature"
            register={registerComplete}
            type="number"
            label={getLabel('analysisExamTemperature')}
            placeholder={getLabel('analysisExamTemperaturePlaceholder') + " (\u00b0C)"}
            error={errorsComplete['temperature']}
            min={{value: 15, message: getLabel('errorMinValue', {value: 15})}}
            max={{value: 35, message: getLabel('errorMaxValue', {value: 35})}}
            // regExpPattern={{value: ALPHA_SPACE_APEX_REGEX, message: getLabel('errorAlphaSpaceApex')}}
        /> */}
        </div>
      )}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
              storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      {operation.id !== undefined && renderAnalysisEvolution()}
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};

export const AutomaticDetail = ({
  type,
  operation,
  users,
  tanks,
  configs,
  lots,
  drugs,
  register,
  errors,
  getValues,
  dispatch,
  user_id,
  setValue,
  axiosPrivate,
  userSockets,
  addChatNote,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [completedState, setCompletedState] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isShowCost, setIsShowCost] = useState(false);

  useEffect(() => {
    const tmp = [];
    if (operation?.src_tanks?.length > 0) tmp.push(operation?.src_tanks?.[0]);
    setTableData(tmp);
  }, [operation]);

  const setCheckboxState = (tank_id) => {
    const newCompletedState = [...completedState];
    const index = newCompletedState.indexOf(tank_id);
    if (index === -1) {
      newCompletedState.push(tank_id);
    } else {
      newCompletedState.splice(index, 1);
    }
    setCompletedState(newCompletedState);
  };

  const getDrugData = (row, type) => {
    const drug = drugs?.find((d) => d?.id == row?.product);
    if (drug === undefined) return "";
    if (type === "range") {
      return (
        `${String(drug?.min_range || "")} - ${String(drug?.max_range || "")} ${
          row?.product_unit || ""
        }` || ""
      );
    } else if (type === "temp") {
      return (
        `${String(drug?.min_temperature || "")} - ${
          drug?.max_temperature ? drug?.max_temperature + " \u00b0C" : ""
        }` || ""
      );
    }
  };

  const columnHelper = createColumnHelper();
  const columns = [
    // columnHelper.accessor(
    //   (row) => getLabel(`protocol_type_${row?.protocol_type}`),
    //   {
    //     header: getLabel("protocol_type"),
    //     cell: TableCell,
    //     isFilterDisabled: true,
    //   }
    // ),
    columnHelper.accessor("product_name", {
      header: getLabel("treatmentName"),
      cell: TableCell,
    }),
    columnHelper.accessor(
      (row) => `${row?.quantity} ${row?.product_unit || ""}`,
      {
        header: getLabel("drugQuantity"),
        cell: TableCell,
        meta: {
          type: "number",
          isFilterDisabled: true,
        },
      }
    ),
    // columnHelper.accessor('product_unit', {
    //   header: getLabel("unit"),
    //   cell: TableCell,
    // }),
    // columnHelper.accessor((row) => getDrugData(row, "range"), {
    //   header: getLabel("substanceRange"),
    //   cell: TableCell,
    //   meta: {
    //     type: "number",
    //     isFilterDisabled: true,
    //   },
    // }),
    columnHelper.accessor(
      (row) => (row?.product_type ? getLabel(`drugType_${row.product_type?.toUpperCase()}`) : ""),
      {
        header: getLabel("drugType"),
        cell: TableCell,
        meta: {
          type: "text",
          isFilterDisabled: true,
          filterVariant: 'text',
        },
      }
    ),
    columnHelper.accessor((row) => `${
        row?.min_temperature ? String(row?.min_temperature) : "n/a"
      } - ${
        row?.max_temperature ? String(row?.max_temperature) : "n/a"
      }`, {
      header: getLabel("substanceTemperature"),
      cell: TableCell,
      meta: {
        type: "number",
        isFilterDisabled: true,
      },
    }),
    columnHelper.accessor("drug_batch_number",
      {
        header: getLabel("drugBatchNumber"),
        cell: TableCell,
        meta: {
          isFilterDisabled: true,
        },
      }
    ),
  ];

  if (isShowCost) {
    columns.push(
      columnHelper.accessor((row) => `${row?.drug_batch_cost ? parseFloat((Number(row?.drug_batch_cost) * Number(row?.total_quantity))).toFixed(2) : ''} ${row?.drug_batch_cost ? "€" : ""}`,
      {
        header: getLabel("drugBatchProductCost"),
        cell: TableCell,
        meta: {
          isFilterDisabled: true,
        },
      }
    ),
    );
  }

  const computeTotalProductToAdd = (drug, liters) => {
    const productName =  drug?.substance_name || null;
    const productQuantity =  Number(drug?.quantity) || 0;
    const unit_id = drug?.unit_id || null;

    if (liters === 0 || productQuantity === 0 || unit_id === null || productName === null) return false;
    let totalProductToAdd = 0;
    switch (unit_id) {
      case 1: // mg/L
        const tmpQuantity1  = parseFloat(liters * productQuantity);
        if (tmpQuantity1 >= 1000 * 1000) totalProductToAdd = parseFloat(tmpQuantity1 / 1000 / 1000).toFixed(2) + " Kg";
        else if (tmpQuantity1 >= 1000) totalProductToAdd = parseFloat(tmpQuantity1 / 1000).toFixed(2) + " g";
        else totalProductToAdd = tmpQuantity1.toFixed(2) + " mg";  
        break;
      case 2: // g/hL
        const tmpQuantity2  = parseFloat((liters / 100) * productQuantity) ;
        if (tmpQuantity2 >= 1000) totalProductToAdd = parseFloat(tmpQuantity2 / 1000).toFixed(2) + " Kg";
        else totalProductToAdd = parseFloat(tmpQuantity2).toFixed(2) + " g";
        break;
        case 3: // L
          break;
        case 4: // Kg
          break;
        case 5: // " "
          break;
          case 6: // g/L
          break;
        case 7: // g/100Kg
          const tmpQuantity7  = parseFloat((liters / 100) * productQuantity) ;
          if (tmpQuantity7 >= 1000) totalProductToAdd = parseFloat(tmpQuantity7 / 1000).toFixed(2) + " Kg";
          else totalProductToAdd = parseFloat(tmpQuantity7).toFixed(2) + " g";
          break;
        case 8: // NTU
        totalProductToAdd =
          parseFloat((liters) * productQuantity).toFixed(2) + " NTU";
          break;
        case 9: // %Vol.
        totalProductToAdd =
          parseFloat((liters) * productQuantity).toFixed(2) + " %Vol.";
          break;
        case 10: // uS/DIT
          totalProductToAdd =
            parseFloat((liters) * productQuantity).toFixed(2) + " uS/DIT";
          break;
      default:
        break;
    }
    return totalProductToAdd;
  }

  const renderTotal = (tank_id) => {
    const mainSrc = operation?.src_tanks?.[0] || null;
    if (mainSrc === null) return '';
    const liters = operation?.completion_date !== null ? operation?.src_tanks?.find((t) => t?.tank_id == tank_id)?.old_quantity : 
      (operation?.src_tanks?.find((t) => t?.tank_id == tank_id)?.preOperation?.tank?.quantity || 
      (tanks?.find((t) => Number(t.id) === Number(tank_id)))?.quantity) || 0;

    const totalDrugs = [];
    let totalCostPerTank = 0;
    
    operation?.treatments?.filter(t => t?.tank_id === tank_id)?.forEach((drug) => {    
      const productName =  drug?.substance_name || null;
      const totalProductToAdd = computeTotalProductToAdd(drug, liters);

      if (totalProductToAdd) {
        const cost = parseFloat(Number(drug?.drug_batch_cost)) || null;
        totalDrugs.push(
          {
            quantity: totalProductToAdd,
            substance_name: productName,
            cost: cost || "-",
          });
          if (Number(cost) > 0) totalCostPerTank += parseFloat((Number(cost) * parseFloat(totalProductToAdd)));
        }
    });
    
    return (<div className="total_drug_wrapper">
      <div className="total_drug">
        {getLabel("drugTotal")}{" "}
        <ul>
          {totalDrugs?.map((totalDrug, index) => {return <li  key={`total_drug_${index}`} className="total_drug_quantity">
            <span className="substance_quantity">{totalDrug?.quantity}</span>
            <span className="substance_name">{totalDrug?.substance_name}</span>
            {index === totalDrugs?.length - 1 ? '' : ''}
          </li>})}
        </ul>
      </div>
      {isShowCost && <div className="total_drug_wrapper">
          <div className="total_drug">
            {getLabel("drugTankCosts")} {Number(totalCostPerTank) > 0 ? ` (${parseFloat(totalCostPerTank).toFixed(2)} €)` : ""}
            <ul>
              {totalDrugs?.map((totalDrug, index) => {return <li  key={`total_drug_cost_${index}`} className="total_drug_cost">
                <span>{Number(totalDrug?.cost) > 0 ? parseFloat((Number(totalDrug?.cost) * parseFloat(totalDrug?.quantity))).toFixed(2) : "-"} {totalDrug?.cost > 0 ? "€" : ""}</span>
                </li>})}
            </ul>
          </div>
      </div>}
    </div>
    );
  };
  
  return (
    <>
      {/* <h4>{getLabel(`operationType${operation?.type}`)}</h4> */}
      <div className={`operation_info_container_row ${operation?.cellarman_ids?.length > 1 ? 'start' : ''}`}>
        <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={getLabel("insertionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            configs.shortDateFormat
          )}
        </Label>
        {operation?.completion_date === null && (
          <>
            <Label label={getLabel("toDoDate")}>
              {format(
                new Date(operation?.expire_date || null),
                configs.shortDateFormat
              )}
            </Label>
            <Label label={getLabel("cellarman")}>
              {
                <div className="cellarman_container">
                  {operation?.cellarman_ids?.map((cellarman, index) => {
                    const cellarmanName =
                      users?.find?.(
                        (user) => Number(user.id) === Number(cellarman)
                      )?.username || "";
                    return (
                      <div key={`cellarma-${index}`}>
                        {cellarmanName +
                          (operation?.cellarman_ids?.length > 1 ? " " : "")}
                      </div>
                    );
                  })}
                </div>
              }
            </Label>
          </>
        )}
        {operation?.completion_date && (
          <>
            <Label label={getLabel("operationCompletionUser")}>
              <div>
                {users?.find?.(
                  (user) => Number(user.id) === Number(operation?.completed_by)
                )?.username || ""}
              </div>
            </Label>
            <Label label={getLabel("operationCompletionDate")}>
              {format(
                new Date(operation?.completion_date || null),
                configs.dateFormat
              )}
            </Label>
          </>
        )}
        <Label label={getLabel("operationPriority")}>
          {getLabel(`operationPriority${operation?.priority}`)}
        </Label>
        {/* <Label label={getLabel("lotType")}>
          {operation?.batch_type ? getLabel(`lotType${operation?.batch_type}`) : ''}
        </Label> */}
      </div>
      <div className="operation_info_container_row">
        <Label label={getLabel("protocolPhase")}>
          {getLabel(`protocolPhase_${operation?.src_tanks?.[0]?.phase}`)}
        </Label>
        <Label label={getLabel("protocolNotes")}>
          {operation?.note || "-"}
        </Label>
        <Label label={getLabel("protocolGoals")}>
          {operation?.src_tanks?.[0]?.goal || "-"}
        </Label>
      </div>
      <h4>{getLabel("protocolOperation")} </h4>
      {["TANNISSAGE", "ENZYME", "SO2", "INOCULATION", "NITROGEN"].includes(
        type
      ) && (
        <>
          <div className="operation_info_container_row">
            <div className="analysis_table">
              <TableEdit
                defaultData={tableData}
                columns={columns}
                isSearchBar={false}
                type={isShowCost ? "treatmentApplication" : role === ROLES.USER ? "treatmentApplicationUser" : "treatment"}
                isLegend={false}
                // rowClickHandler={
                //   !isProtocolApplication
                //     ? (row) => {
                //         navigate(`/substances/${type}/${row.original.id}`);
                //       }
                //     : null
                // }
                isEditable={false}
              />
            </div>
          </div>
        </>
      )}
      {type === "HOMOGENIZATION_MASS" && (
        <>
          <div className="operation_info_container_row">
            {operation?.treatments?.[0]?.protocol_type ===
              "HOMOGENIZATION_TEMP" && (
              <>
                <Label
                  label={getLabel("protocolOperation_HOMOGENIZATION_TEMP")}
                >
                  {`${operation?.treatments?.[0]?.quantity} \u00b0C`}
                </Label>
              </>
            )}
            {operation?.treatments?.[0]?.protocol_type ===
              "HOMOGENIZATION_REASSEMBLY" && (
              <>
                <Label label={getLabel("protocolHomogenizationType")}>
                  {getLabel(
                    `protocolHomogenizationMass_${operation?.treatments?.[0]?.homogenization_type}`
                  )}
                </Label>
                <Label label={getLabel("protocolHomogenizationWorkTime")}>
                  {operation?.treatments?.[0]?.work_time}
                </Label>
                <Label label={getLabel("protocolHomogenizationPauseTime")}>
                  {operation?.treatments?.[0]?.homogenization_pause_time}
                </Label>
                <Label label={getLabel("protocolHomogenizationMotorSpeed")}>
                  {operation?.treatments?.[0]?.homogenization_motor_speed}
                </Label>
                <Label label={getLabel("protocolHomogenizationIterPerDay")}>
                  {operation?.treatments?.[0]?.iter_per_day}
                </Label>
              </>
            )}
          </div>
        </>
      )}
      {type === "OXYGENATION" && ['MICRO', 'MACRO', 'CUSTOM'].includes(operation?.treatments?.[0]?.protocol_type) && (
        <>
          <div className="operation_info_container_row">
            <Label
              label={getLabel("protocolOxigenationTypology")}
            >
              {getLabel(`protocolOXYGENATION_${operation?.treatments?.[0]?.protocol_type}`)}
            </Label>
            <Label
              label={getLabel("protocolOxygenationDoseNoUnit")}
            >
              {operation?.treatments?.[0]?.quantity || ''}{" "}
                {'MICRO' === operation?.treatments?.[0]?.protocol_type ? getLabel("protocolOxygenationNoDose_MACRO")
                  : 'MACRO' === operation?.treatments?.[0]?.protocol_type ? getLabel("protocolOxygenationNoDose_MACRO")
                  : `${getLabel("protocolOxygenationNoDose_CUSTOM")} ${operation?.treatments?.[0]?.oxygenation_dose_hours || ''}h:${operation?.treatments?.[0]?.oxygenation_dose_minutes || ''}m`
                }
            </Label>
            {/* {'CUSTOM' === operation?.treatments?.[0]?.protocol_type &&
            <Label
              label={getLabel("protocolOxygenationDoseCustomTime")}
            >
              {`$`}
            </Label>
            } */}
          </div>
        </>
      )}
      <div className="operation_info_container_title">
        <h4>{getLabel("toTanks")}</h4>
        {["TANNISSAGE", "ENZYME", "SO2", "INOCULATION", "NITROGEN"].includes(
            type
          ) && (role === 2 ||
          (role === ROLES.USER &&
            users?.filter((u) => u?.type === "USER")?.length ===
              0)) && <CTA customClassName={!isShowCost ? "add" : "complete"} onClick={() => setIsShowCost(!isShowCost)}>
          {getLabel(isShowCost ? "fromTanksAnalysisHideCost" : "fromTanksAnalysisShowCost")}
        </CTA>}
      </div>
      <ul>
        {operation?.src_tanks?.map((srcTank, idx) => {
          return (
            <li key={`li-${idx}`}>
              <div className="operation_info_container_row">
              <div className="operation_info_container_row_total">
                <SrcTankDetail
                  key={`src-automatic-${srcTank.tank_id}`}
                  // tank={getTankData(srcTank)}
                  tank={srcTank}
                  isCurrentStateOnly={true}
                  totalDrug={[
                    "TANNISSAGE",
                    "ENZYME",
                    "SO2",
                    "INOCULATION",
                    "NITROGEN",
                    'BOIS',
                  ].includes(type) ? renderTotal(srcTank?.tank_id) : null}
                >
                </SrcTankDetail>
                </div>
                {operation?.completion_date === null &&
                  (role === 3 ||
                    (role === ROLES.CLIENT &&
                      users?.filter((u) => u?.type === "USER")?.length ===
                        0)) && (
                    <>
                      <Input
                        name={`completed.${srcTank.tank_id}`}
                        register={register}
                        error={errors[`completed.${srcTank.tank_id}`]}
                        required={getLabel("inputRequiredError")}
                        isLabel={false}
                        type={"checkbox"}
                        checked={completedState.includes(srcTank.tank_id)}
                        onChange={() => setCheckboxState(srcTank.tank_id)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                            setCheckboxState(srcTank.tank_id); // Change the checkbox state
                            setValue(`completed.${srcTank.tank_id}`, !completedState.includes(srcTank.tank_id));
                          }
                        }}
                        customClassName={'confirm'}
                      />
                    </>
                  )}
              </div>
            </li>
          );
        })}
      </ul>
      {/* <h4>{getLabel("operationPomaces")} </h4>
      <ul>
        <div>
          <ul>
            {operation?.pomaces?.map((pomace) => {
              return (
                <li>
                  <div>
                    {pomace.dest}: {pomace.quantity || 0}%
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </ul> */}
      {/* <div className="operation_info_container_row">
        <Label label={getLabel("operationNotes")} width={400} height={150} customClassName={"notes"}>
          {operation?.note}
        </Label>
      </div> */}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
            storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};

export const BottlingDetail = ({
  operation,
  users,
  tanks,
  configs,
  getValues,
  register,
  errors,
  type,
  dispatch,
  setValue,
  user_id,
  axiosPrivate,
  userSockets,
  addChatNote,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [completedState, setCompletedState] = useState([]);

  const setCheckboxState = (batch_id) => {
    const newCompletedState = [...completedState];
    const index = newCompletedState.indexOf(batch_id);
    if (index === -1) {
      newCompletedState.push(batch_id);
    } else {
      newCompletedState.splice(index, 1);
    }
    setCompletedState(newCompletedState);
  };

  const getLotInfo = (src) => {
    const tank = operation?.completion_date !== null ? operation?.dest_tanks?.find((d) => d?.postOperation?.batch?.old_batch_id == src?.postOperation?.batch?.batch_id) || null :
    operation?.dest_tanks?.find((d) => d?.tank_id == src?.tank_id) || null;
    if (tank === null) return;
    const drop = operation?.completion_date !== null ? Number(operation?.drops?.find((d) => d?.tank_id === src?.tank_id)?.quantity) || 0 : 0;
    
    return (<div className="tag-fix">
        <Label label={getLabel("lot")}>
        {tank?.new_batch_name || ''} {`(${(Number(tank?.quantity) - drop) || '0'} L)`}
      </Label>
      <p className="timeline-tag">
        {["NEW", "INHERITED"].includes(
          tank?.new_batch_type
        )
          ? getLabel("new")
          : ""}
      </p>
    </div>)
  }

  const renderBottleIcon = (destTank) => {
    // needed because, given a new BOTTLED batch, I can have multiple bottles
    const tmpBottles = destTank?.bottles || [];
    const bottles = tmpBottles?.filter(b => b?.batch_id === destTank?.drop_batch_id) || [];

    return (bottles?.map((b, index) => {    
      return (
        <div className="operation_info_container_row" key={`dest-bottling-${index}`}>
            <BottleIcon
          key={`bottle-${index}-${destTank?.drop_batch_id}`}
          color={destTank?.color}
          quantity={b?.quantity - Number(destTank?.drop || 0)}
          drop={Number(destTank?.drop || 0)}
          batch_name={destTank?.batch_name}
          capLot={b?.cap_lot}
          bottleLot={b?.bottle_lot}
          isDetail={true}
        />
        {(role === 3 || (role === ROLES.CLIENT &&
          users?.filter((u) => u?.type === "USER")?.length ===
            0)) && operation.completion_date == null && (
        <>
          <Input
            name={`completed.${destTank?.drop_batch_id}`}
            register={register}
            error={errors[`completed.${destTank?.drop_batch_id}`]}
            required={getLabel("inputRequiredError")}
            type={"checkbox"}
            isLabel={false}
            checked={completedState.includes(destTank?.drop_batch_id)}
            onChange={() => setCheckboxState(destTank?.drop_batch_id)}
            customClassName={'confirm'}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                setCheckboxState(destTank?.drop_batch_id); // Change the checkbox state
                setValue(`completed.${destTank?.drop_batch_id}`, !completedState.includes(destTank?.drop_batch_id));
              }
            }}
          />
          <Input
            name={`drop.${destTank?.drop_batch_id}`}
            label={getLabel("operationDrop")}
            placeholder={getLabel("operationDropPlaceholder")}
            register={register}
            error={errors[`drop`]?.[destTank?.drop_batch_id]}
            // required={getLabel("inputRequiredError")}
            type={"number"}
            defaultValue={0}
            min={{
              value: 0,
              message: getLabel("errorMinValue", { value: "0" }),
            }}
            max={{
              value:
                Number(destTank?.quantity) - 1, // TO DO: aggiustare coefficiente
              message: getLabel("errorMaxValue", {
                value: Number(destTank?.quantity) - 1,
              }),
            }}
            // Math.max(0, Number(src_tanks?.[0].quantity)),
          />
          </>)
        }
      </div>)}));
  }

  return (
    <>
      {/* <h3>{getLabel(`operationType${operation?.type}`)}</h3> */}
      <div className={`operation_info_container_row ${operation?.cellarman_ids?.length > 1 ? 'start' : ''}`}>
        <Label label={getLabel("insertionBy")}>
          <div>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </div>
        </Label>
        <Label label={getLabel("insertionDate")}>
          {format(
            new Date(operation?.insertion_date || null),
            configs.shortDateFormat
          )}
        </Label>
        {operation?.completion_date === null && <Label label={getLabel("expireDate")}>
          {format(
            new Date(operation?.expire_date || null),
            configs.shortDateFormat
          )}
        </Label>}
        {operation?.completion_date && (
          <>
            <Label label={getLabel("operationCompletionUser")}>
              <div>
                {users?.find?.(
                  (user) => Number(user.id) === Number(operation?.completed_by)
                )?.username || ""}
              </div>
            </Label>
            <Label label={getLabel("operationCompletionDate")}>
              {format(
                new Date(operation?.completion_date || null),
                configs.dateFormat
              )}
            </Label>
          </>
        )}
        <Label label={getLabel("cellarman")}>
          {
            <div className="cellarman_container">
              {operation?.cellarman_ids?.map((cellarman) => {
                const cellarmanName =
                  users?.find?.((user) => Number(user.id) === Number(cellarman))
                    ?.username || "";
                return (
                  <div>
                    {cellarmanName +
                      (operation?.cellarman_ids?.length > 1 ? " " : "")}
                  </div>
                );
              })}
            </div>
          }
        </Label>
      </div>
      <div className={"confirmation-modal-container"}>
        <h4>{getLabel("operationDetail")}</h4>
        <OperationRecap
          type={type}
          isScale={false}
          src_tanks={getRecapTanks(tanks, operation, true)}
          dest_tanks={[]}
        />
      </div>
      <h4>{getLabel("fromTank")}</h4>
      {[operation?.src_tanks?.[0]]?.map((srcTank, index) => {
        return (
          <div className="operation_info_container_row" key={`src-bottling-${index}`}>
            <SrcTankDetail
              key={`src-${srcTank?.tank_id || index}`}
              tank={actualizeSrcTank(operation?.type, operation?.completion_date, srcTank, tanks, true)}
              // operation={operation}
            ></SrcTankDetail>
            <div>
              {/* {getLotInfo(srcTank)} */}
            </div>
          </div>
        );
      })}
      {/* <h3>{getLabel("toTank")}</h3> */}
      <h4>{getLabel("toTanks")}</h4>
      {operation?.dest_tanks?.map((destTank, index) => {
        return renderBottleIcon(destTank, index)}
      )}
      {/* <div className="operation_info_container_row">
        <Label label={getLabel("operationNotes")} width={400} height={150} customClassName={"notes"}>
          {operation?.note}
        </Label>
      </div> */}
      {/* <div className="operation_info_container_row">
        <ChatArea
          name="chat"
          register={register}
          label={getLabel("lotNotes")}
          placeholder={getLabel("lotNotesPlaceholder")}
          users={users}
          user_id={user_id}
          // tooltip={getLabel("lotNotesTooltip")}
          configs={configs}
          operation={operation}
          storeNote={() =>
            storeNote(
              axiosPrivate,
              dispatch,
              setValue,
              getValues,
              getLabel,
              operation,
              user_id,
              userSockets,
              users,
              addChatNote,
            )
          }
        />
      </div>
      <div className="operation_info_container_row additional">
        <Label label={getLabel("demandant")}>
          {users?.find?.(
            (user) => Number(user.id) === Number(operation?.user_id)
          )?.username || ""}
        </Label>
        <Label label={getLabel("updateDate")}>
          {format(new Date(operation?.update_date || null), configs.dateFormat)}
        </Label>
      </div> */}
    </>
  );
};
